function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawMobileBrowsers = function UndrawMobileBrowsers(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1077.87 830.33",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 0.93,
    y1: 901.66,
    x2: 0.93,
    y2: 901.62,
    gradientTransform: "matrix(923.39 0 0 -923.39 -144.23 832770.04)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#86bbe5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1072ba"
  })), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 1.04,
    y1: 900.82,
    x2: 1.04,
    y2: 900.88,
    gradientTransform: "matrix(2421.88 0 0 -2421.88 -2442.88 2182095.07)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.25,
    stopColor: "#dbdbda"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), React.createElement("radialGradient", {
    id: "prefix__d",
    cx: 1.01,
    cy: 900.89,
    r: 0.04,
    gradientTransform: "matrix(2240.23 0 0 -2240.23 -2170.42 2018527.63)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#2abce1"
  }), React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2abbe1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3375f8"
  })), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 1,
    y1: 900.89,
    x2: 0.99,
    y2: 900.86,
    gradientTransform: "matrix(2240.23 0 0 -2240.23 -2163.79 2018526.69)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1
  })), React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 228.65,
    y1: 849.79,
    x2: 228.65,
    y2: 390.48,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__f",
    x1: 980.95,
    y1: 422.53,
    x2: 980.95,
    y2: 420.56,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__g",
    x1: 1069.87,
    y1: 642.26,
    x2: 1069.87,
    y2: 632.24,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__h",
    x1: 972.81,
    y1: 288.48,
    x2: 972.81,
    y2: 288.24,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__i",
    x1: 1002.06,
    y1: 694.42,
    x2: 1002.06,
    y2: 258.08,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__j",
    x1: 611.37,
    y1: 587.56,
    x2: 611.37,
    y2: 234.5,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M663.83 111.34c-46.25 39.26-106.24 36.72-158.81 16.29S404.16 70.84 352.94 44.99c-42.94-21.67-88-35.9-133.61-42.23-65.28-9-138.18 2-183.66 65.44-50.65 70.68-46.76 198.16 8 263 27.87 33 64.36 49.2 96.18 75s61.28 68.56 58.57 118.29c-2.51 46-31.68 81.38-61.87 103.54-23.33 17.14-52.06 35.85-54.87 71.33-2.72 34.34 21.44 61.24 44.51 76.54 75.26 49.92 168 49.44 243-1.26 26.75-18.08 51.34-42.13 79.39-56.23 73.65-37 154.81.25 232.8 13.87 66 11.53 133.69 5.56 198-17.47 38.62-13.83 77.39-35 104.52-74.37 19.57-28.4 31.76-64.34 43.2-99.84q18.3-56.79 35.19-114.37c6.75-23 13.4-46.54 15.15-71.19 3.16-44.68-10.16-88.84-28.3-126.55-43.1-89.51-115.64-152.46-194.2-168.46s-161.67 15.25-222.6 83.59",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1,
    fill: primaryColor
  }, React.createElement("path", {
    d: "M274.59 237.5s-27.31 6.34-34.87 22l-8.29-2.93v10.19l-17.31-4.6s11.7 6.34 5.12 14.63-26.3 23.14-26.3 23.14-13.41-12.44 4.64-36.58 56.78-41.46 77.01-25.85z"
  }), React.createElement("path", {
    d: "M272.64 230.43s-47.11-66.57-112.31-12.19c0 0 20.38 1 25.75 4.63 0 0 .24-13.9 4.87-10.24l2.69 10.73 15.11 2.19s3.52-12.43 7.74-10.24l5.68 10.73 12.19.73s2.44-11.22 5.12-9.51 4.88 8.54 4.88 8.54 21.46-1.22 28.28 4.63z"
  }), React.createElement("path", {
    d: "M277.28 230.43l-11.22-27.27s.49-9.51 3.66-10l-6.1 2.44-5.12-5.85 3.66-9.51s-7.32 7.07-9.76 7.07-17.55-9.51-17.55-9.51l7.56-9s-9.76 10.49-17.32 7.08-34.15-15.44-25.85-17.88 24.88-15.11 51.21-1.46 46.82 48.53 26.83 73.89zM282.15 230.43l18.54-33.56 6.83 1.86-1.22-10.24 14.38-9.76 3.17 5.12v-10.69l16.34-6.09 4.15 4.39s-2.44-9.51 10-8 17.32-.15 17.32-.15-11.72 16.64-18.79 22.62l-9.26-3.05 4 8.78-17.16 10s-10.24-6.64-10.73-4.78l4.14 8.48s-42.68 20.44-41.71 25.07zM288.74 234.57s10-18.28 25.36-16.82l4.63 5.85s-4.14-9.75 12.44-13.17 40.48-5.08 40.48-5.08l4.39 8.3 5.12-8.3 18.29 8.3s-4.15 14.58-33.41 16.78l-4.63-7.07-.74 7.07-16.58 5.36s-4.14-8.78-5.85-7.56-1 7.56-1 7.56-24.12 6.37-48.5-1.22zM283.86 238.28s3.9 26.53 9.27 29.7 15.12 4.88 15.12 4.88l-15.85 1.95 8 12.68 14.88 6.83-11.22 2.19-.73 6.59 6.34 2.92-7.28 3.14s-4.87 18.29-11.94 27.07c0 0 18.77-4.63 24.87-14.63s9-25.61 9-25.61 1-22.92-3.17-29-32.66-30.36-37.29-28.71zM277.76 244.82l-3.17 1.95-5.85 12.19h10.24l-1.22-14.14zM276.79 261.4l-10 2.19v7.32s5.85 2.19 5.85 4.14zM263.86 272.62l-2.44 10.49 8.78 4.13v-9.5l-6.34-5.12zM260.57 285.78l-3.17 17.44s8.9-4.51 10.49-3.29l.85-9.27s-5.8-6.22-8.17-4.88zM256.55 306.39l.85 5.73 10.25 3.04v-10.48l-2.57-3s-8.91 2.13-8.53 4.71zM255.09 315.16c.12.73 0 15.12 0 15.12h13l-.48-11.59zM255.08 332l1.45 17.56 12.21-7.44-.61-8.42-13.05-1.7zM256.53 351.63l.87 12.07 14.87-.85-2.07-19.03-13.67 7.81zM257.4 367.11l2.44 11.34 14.75-2.56-2.32-10.61-14.87 1.83zM259.23 382.6l2.38 8.9 16.39 2.44-2.68-13.54-16.09 2.2zM261.94 395.27l6.71 22.68s7.93-14.26 13.41-13.41l-2.68-8.54s-16.12-2.56-17.44-.73zM269.6 420.76l5 13.29s16-6 18.29-4.39l-10-23.38s-9.27 13.99-13.29 14.48zM276.79 437.34l7.19 14.39 15.24-9.51-6.34-10.36-16.09 5.48zM285.93 454.29l5.97 9.39h24.27l-15.12-19.14-15.12 9.75zM292.88 466.85l17.07 23.29 17.19-14.64-8.41-8.65h-25.85zM328.73 478.49l-16.59 13.11 22.32 8.53 7.92-9.99-13.65-11.65zM426.42 298.43s21.06 4.88 26.89 16.92l6.39-2.26v7.9l13.35-3.58s-9 4.89-4 11.28 20.3 17.86 20.3 17.86 10.34-9.58-3.57-28.2-43.75-31.96-59.36-19.92z"
  }), React.createElement("path", {
    d: "M427.94 292.97s36.32-51.32 86.59-9.4c0 0-15.72.76-19.85 3.58 0 0-.19-10.72-3.76-7.9l-2.07 8.27-11.66 1.69s-2.71-9.58-6-7.89l-4.38 8.27-9.4.56s-1.88-8.64-4-7.33-3.76 6.58-3.76 6.58-16.46-.94-21.71 3.57z"
  }), React.createElement("path", {
    d: "M424.35 292.97l8.65-21.05s-.37-7.33-2.82-7.71l4.7 1.88 3.95-4.51-2.82-7.33s5.64 5.45 7.52 5.45 13.54-7.33 13.54-7.33l-5.83-7s7.52 8.08 13.35 5.45 26.35-11.8 19.92-13.66-19.17-11.66-39.48-1.13-36.09 37.39-20.68 56.94zM420.59 292.97L406.3 267.1l-5.26 1.43.94-7.89-11.04-7.48-2.45 4v-8.28l-12.59-4.7-3.2 3.39s1.88-7.33-7.71-6.21-13.34-.11-13.34-.11 9 12.9 14.47 17.5l7.15-2.35-3.09 6.77 13.24 7.71s7.89-5.12 8.27-3.69l-3.2 6.54s32.86 15.67 32.1 19.24zM415.52 296.16s-7.71-14.1-19.56-13l-3.57 4.51s3.2-7.52-9.59-10.15-31.2-3.92-31.2-3.92l-3.39 6.4-3.95-6.4-14.1 6.4s3.2 11.24 25.76 12.93l3.57-5.45.57 5.45 12.78 4.23s3.2-6.77 4.51-5.83.75 5.83.75 5.83 18.62 4.84 37.42-1zM419.28 299.03s-3 20.45-7.15 22.9-11.65 3.76-11.65 3.76l12.22 1.5-6.21 9.78-11.47 5.26 8.65 1.69.57 5.08-4.89 2.25 5.64 2.45s3.76 14.1 9.21 20.87c0 0-14.48-3.57-19.18-11.28s-6.95-19.74-6.95-19.74-.75-17.68 2.44-22.38 25.2-23.42 28.77-22.14zM423.97 304.07l2.45 1.5 4.51 9.41h-7.9l.94-10.91zM424.73 316.85l7.71 1.69v5.62s-4.51 1.69-4.51 3.2zM434.69 325.5l1.88 8.09-6.77 3.18v-7.32l4.89-3.95zM437.23 335.65l2.45 13.44s-6.87-3.48-8.09-2.54l-.66-7.14s4.52-4.79 6.3-3.76zM440.33 351.54l-.65 4.42-7.9 2.35v-8.09l2-2.35s6.85 1.68 6.55 3.67zM441.46 358.31c-.09.56 0 11.65 0 11.65H431.4l.38-8.93zM441.46 371.28l-1.12 13.54-9.41-5.74.47-6.48 10.06-1.32zM440.34 386.42l-.67 9.3-11.47-.66 1.6-14.66 10.54 6.02zM439.67 398.35l-1.88 8.75-11.37-1.98 1.78-8.18 11.47 1.41zM438.26 410.29l-1.83 6.86-12.65 1.89 2.07-10.44 12.41 1.69zM436.2 420.06l-5.17 17.49s-6.11-11-10.34-10.34l2.07-6.58s12.4-1.98 13.44-.57zM430.28 439.71l-3.86 10.25s-12.31-4.61-14.1-3.39l7.71-18s7.14 10.76 10.25 11.14zM424.72 452.5l-5.54 11.09-11.75-7.33 4.89-7.99 12.4 4.23zM417.67 465.56l-4.6 7.24h-18.71l11.66-14.75 11.65 7.51zM412.32 475.25l-13.16 17.95-13.26-11.28 6.49-6.67h19.93zM384.68 484.22l12.78 10.11-17.2 6.58-6.11-7.71 10.53-8.98z"
  }), React.createElement("path", {
    d: "M249.11 506.58s50.81-21.62 92.34-17a83.85 83.85 0 0 0 8.54.55c17 .18 77 1.85 104.69 16.43z"
  })), React.createElement("g", {
    opacity: 0.6
  }, React.createElement("path", {
    d: "M653.84 123.68s27-1.22 41.38 26h-43.68s-8.24-.26-15.28 9.73c-2 4.2-4.2 8.52-1.76 17-3.51-5.95-18.65-32.32-18.65-32.32s10.68-19.34 38-20.41z",
    fill: "#ef3f36"
  }), React.createElement("path", {
    d: "M693.81 192.67s-12.47 24-43.17 22.84c3.8-6.56 21.85-37.82 21.85-37.82s4.36-7-.79-18.1c-2.61-3.86-5.28-7.89-13.88-10 6.92-.06 37.32 0 37.32 0s11.39 18.89-1.33 43.08z",
    fill: "#fcd900"
  }), React.createElement("path", {
    d: "M614.06 192.86s-14.57-22.82 1.81-48.81c3.78 6.57 21.83 37.82 21.83 37.82s3.89 7.29 16.07 8.37c4.64-.34 9.46-.63 15.63-7-3.4 6-18.65 32.31-18.65 32.31s-22.1.41-36.69-22.7z",
    fill: "#61bc5b"
  }), React.createElement("path", {
    d: "M650.63 215.74l6.15-25.64a20.59 20.59 0 0 0 12.41-6.73c-3.52 6.18-18.56 32.37-18.56 32.37z",
    fill: "#5ab055"
  }), React.createElement("path", {
    d: "M633.26 169.99a20.47 20.47 0 1 1 20.47 20.47 20.47 20.47 0 0 1-20.47-20.47z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M697.75 204.83a17 17 0 1 1 17 17 17 17 0 0 1-17-17z",
    transform: "translate(-61.06 -34.84)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M695.13 149.57l-25.3 7.42a20.52 20.52 0 0 0-12-7.42h37.32z",
    fill: "#eaca05"
  }), React.createElement("path", {
    d: "M634.01 175.48c-3.55-6.16-18.16-31.39-18.16-31.39l18.73 18.53a18.47 18.47 0 0 0-1.2 9.62l.63 3.24z",
    fill: "#df3a32"
  })), React.createElement("path", {
    d: "M779.71 329.06h48.32c0-17.16-7.48-28.85-27.89-28.85-24.12 0-48.65 15.7-60.31 35.28 3.61-34 28-61.42 64.66-61.42 31.44 0 61.23 24 61.23 64v15.19h-85.78c0 20.68 18 28.87 36.93 28.87 23 0 37.23-10.33 37.23-10.33v29s-16.07 9.76-41.69 9.76c-33.3 0-56.8-23.86-56.8-53.53a52.62 52.62 0 0 1 33.6-49.56c-9.49 10.44-9.53 21.62-9.53 21.62z",
    fill: "#3277bc",
    opacity: 0.6
  }), React.createElement("ellipse", {
    cx: 991.07,
    cy: 687.99,
    rx: 111.1,
    ry: 13.79,
    transform: "rotate(-9.27 745.414 1046.98)",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.6
  }, React.createElement("circle", {
    cx: 75.2,
    cy: 338.65,
    r: 70.91,
    fill: "url(#prefix__c)"
  }), React.createElement("circle", {
    cx: 75.2,
    cy: 338.65,
    r: 65.59,
    fill: "url(#prefix__d)"
  }), React.createElement("path", {
    d: "M75.31 289.01a.81.81 0 0 1-.83-.78v-11.58a.83.83 0 0 1 1.66 0v11.58a.84.84 0 0 1-.83.78z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M75.31 289.06a.86.86 0 0 1-.88-.83v-11.58a.86.86 0 0 1 .88-.83.87.87 0 0 1 .89.83v11.58a.9.9 0 0 1-.89.83zm0-13.13a.78.78 0 0 0-.77.72v11.58a.74.74 0 0 0 .77.72.78.78 0 0 0 .78-.72v-11.58a.84.84 0 0 0-.78-.72z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M80.85 282.8a.84.84 0 0 1-.77-.83l.38-5.15a.81.81 0 0 1 .89-.72.85.85 0 0 1 .78.83l-.39 5.15a.8.8 0 0 1-.89.72z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M80.85 282.86a.91.91 0 0 1-.83-.89l.39-5.15a.87.87 0 0 1 .94-.78.91.91 0 0 1 .83.89l-.39 5.15a.83.83 0 0 1-.94.78zm.5-6.71a.73.73 0 0 0-.77.67l-.39 5.15a.78.78 0 0 0 .72.78.73.73 0 0 0 .77-.67l.39-5.15a.83.83 0 0 0-.72-.78z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M85.01 290a.85.85 0 0 1-.67-.94l2.27-11.35a.77.77 0 0 1 1-.61.85.85 0 0 1 .66.94l-2.33 11.36a.83.83 0 0 1-.94.6z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M85.01 290.06a.9.9 0 0 1-.72-1l2.27-11.35a.89.89 0 0 1 1-.67.9.9 0 0 1 .72 1l-2.27 11.36a.93.93 0 0 1-1 .66zm2.6-12.91a.81.81 0 0 0-.89.56l-2.27 11.35a.79.79 0 0 0 .61.89.8.8 0 0 0 .89-.56l2.27-11.35a.8.8 0 0 0-.61-.88z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M91.65 285.02a.82.82 0 0 1-.6-1l1.38-5a.79.79 0 0 1 1-.56.83.83 0 0 1 .61 1l-1.39 5a.79.79 0 0 1-1 .56z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M91.65 285.07a.83.83 0 0 1-.6-1.05l1.38-5a.88.88 0 0 1 1-.61.83.83 0 0 1 .61 1.05l-1.38 5a.85.85 0 0 1-1.05.61zm1.83-6.48a.77.77 0 0 0-.94.5l-1.38 5a.7.7 0 0 0 .55.88.77.77 0 0 0 .94-.5l1.39-5a.8.8 0 0 0-.56-.89z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M94.37 292.83a.79.79 0 0 1-.44-1.05l4.43-10.69a.76.76 0 0 1 1.05-.39.79.79 0 0 1 .44 1l-4.43 10.69a.76.76 0 0 1-1 .39z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M94.37 292.89a.87.87 0 0 1-.5-1.11l4.43-10.69a.89.89 0 0 1 1.17-.45.86.86 0 0 1 .49 1.11l-4.43 10.69a.86.86 0 0 1-1.16.45zm5-12.14a.76.76 0 0 0-1 .39l-4.43 10.69a.72.72 0 0 0 .44.94.75.75 0 0 0 1-.38l4.43-10.7a.79.79 0 0 0-.44-.94z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M101.85 289.28a.83.83 0 0 1-.39-1.05l2.33-4.6a.82.82 0 0 1 1.11-.33.83.83 0 0 1 .38 1.05l-2.32 4.6a.81.81 0 0 1-1.11.33z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M101.85 289.34a.84.84 0 0 1-.39-1.16l2.33-4.6a.87.87 0 1 1 1.55.77l-2.33 4.6a.85.85 0 0 1-1.16.39zm3.05-6a.74.74 0 0 0-1 .33l-2.33 4.6a.83.83 0 0 0 .33 1 .74.74 0 0 0 1-.33l2.33-4.6a.83.83 0 0 0-.29-1.04z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M102.94 297.48a.76.76 0 0 1-.23-1.1l6.43-9.59a.79.79 0 0 1 1.11-.22.76.76 0 0 1 .22 1.11l-6.43 9.58a.74.74 0 0 1-1.1.22z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M102.94 297.54a1 1 0 0 1-.28-1.22l6.43-9.58a.87.87 0 0 1 1.21-.23 1 1 0 0 1 .28 1.22l-6.43 9.59a.88.88 0 0 1-1.21.22zm7.31-10.91a.77.77 0 0 0-1.05.16l-6.43 9.59a.72.72 0 0 0 .22 1 .78.78 0 0 0 1.05-.16l6.43-9.53a.79.79 0 0 0-.22-1z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M111.04 295.43a.79.79 0 0 1-.16-1.1l3.21-4.05a.79.79 0 0 1 1.11-.11.8.8 0 0 1 .16 1.11l-3.21 4a.79.79 0 0 1-1.11.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M110.99 295.49a.88.88 0 0 1-.17-1.22l3.22-4a.81.81 0 0 1 1.21-.11.86.86 0 0 1 .17 1.21l-3.21 4.05a.82.82 0 0 1-1.22.07zm4.15-5.26a.71.71 0 0 0-1 .11l-3.21 4a.78.78 0 0 0 .16 1 .73.73 0 0 0 1.06-.11l3.21-4a.77.77 0 0 0-.17-1.05z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M110.49 303.74a.75.75 0 0 1 0-1.11l8.2-8.14a.79.79 0 0 1 1.11 0 .8.8 0 0 1 0 1.11l-8.15 8.14a.79.79 0 0 1-1.16 0z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M110.43 303.8a.88.88 0 0 1 0-1.22l8.2-8.14a.86.86 0 1 1 1.22 1.21l-8.2 8.15a.88.88 0 0 1-1.22 0zm9.37-9.31a.77.77 0 0 0-1.06 0l-8.19 8.14a.77.77 0 0 0 0 1.06.78.78 0 0 0 1 0l8.2-8.15a.78.78 0 0 0 0-1.05z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M118.8 303.3a.78.78 0 0 1 .06-1.11l3.93-3.32a.81.81 0 0 1 1.05 1.22l-3.9 3.32a.79.79 0 0 1-1.14-.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M118.74 303.36a.87.87 0 0 1 .06-1.22l3.93-3.33a.84.84 0 0 1 1.22.11.87.87 0 0 1 0 1.22l-4.01 3.33a.84.84 0 0 1-1.22-.11zm5.1-4.38a.78.78 0 0 0-1.05-.11l-3.93 3.29a.77.77 0 0 0 1 1.17l3.94-3.33a.72.72 0 0 0 .04-1.02z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M116.58 311.28a.76.76 0 0 1 .23-1.11l9.63-6.43a.85.85 0 0 1 1.11.22.75.75 0 0 1-.22 1.11l-9.64 6.43a.88.88 0 0 1-1.11-.22z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M116.53 311.28a.88.88 0 0 1 .22-1.22l9.64-6.43a.86.86 0 0 1 1.22.28.89.89 0 0 1-.22 1.22l-9.64 6.42a.85.85 0 0 1-1.22-.27zm11-7.26a.73.73 0 0 0-1-.22l-9.64 6.42a.763.763 0 0 0 .83 1.28l9.64-6.43a.79.79 0 0 0 .17-1.05z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M124.84 312.44a.81.81 0 0 1 .28-1.11l4.48-2.55a.83.83 0 0 1 1.11.34.8.8 0 0 1-.28 1.1l-4.49 2.55a.82.82 0 0 1-1.11-.33z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M124.78 312.5a.87.87 0 0 1 .28-1.17l4.49-2.55a.89.89 0 0 1 1.16.34.86.86 0 0 1-.28 1.16l-4.49 2.55a.91.91 0 0 1-1.17-.33zm5.87-3.33a.69.69 0 0 0-1-.28l-4.49 2.55a.81.81 0 0 0-.28 1 .7.7 0 0 0 1 .28l4.49-2.55a.76.76 0 0 0 .28-1.01z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M121.13 319.81a.77.77 0 0 1 .44-1l10.69-4.44a.84.84 0 0 1 1.05.45.77.77 0 0 1-.44 1.05l-10.69 4.43a.79.79 0 0 1-1.05-.49z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M121.07 319.86a.92.92 0 0 1 .44-1.16l10.7-4.43a.85.85 0 0 1 1.1.5.91.91 0 0 1-.44 1.16l-10.69 4.43a.86.86 0 0 1-1.11-.5zm12.13-5a.78.78 0 0 0-.94-.44l-10.69 4.43a.76.76 0 0 0-.39 1 .79.79 0 0 0 .94.44l10.7-4.43a.76.76 0 0 0 .38-1.04z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M128.94 322.58a.79.79 0 0 1 .5-1.05l4.87-1.61a.78.78 0 0 1 1 .5.81.81 0 0 1-.5 1.05l-4.87 1.61a.76.76 0 0 1-1-.5z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M128.88 322.63a.84.84 0 0 1 .56-1.1l4.87-1.61a.89.89 0 0 1 1.11.55.85.85 0 0 1-.56 1.11l-4.87 1.58a1 1 0 0 1-1.11-.53zm6.43-2.1a.77.77 0 0 0-.94-.5l-4.88 1.61a.73.73 0 0 0-.44.94.77.77 0 0 0 .94.5l4.88-1.61a.77.77 0 0 0 .44-.94z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M123.94 329.16a.75.75 0 0 1 .61-.94l11.39-2.21a.81.81 0 0 1 .94.67.75.75 0 0 1-.61.94l-11.33 2.22a.83.83 0 0 1-1-.68z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M123.84 329.16a.89.89 0 0 1 .67-1.05l11.35-2.22a.86.86 0 0 1 1 .72.89.89 0 0 1-.67 1.05l-11.35 2.22a.86.86 0 0 1-1-.72zm12.91-2.49a.74.74 0 0 0-.83-.61l-11.36 2.21a.72.72 0 0 0-.55.89.73.73 0 0 0 .83.61l11.35-2.22a.74.74 0 0 0 .56-.88z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M131.04 333.44a.77.77 0 0 1 .67-.89l5.09-.61a.81.81 0 0 1 .89.72.77.77 0 0 1-.66.89l-5.09.61a.85.85 0 0 1-.89-.72z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M130.99 333.44a.87.87 0 0 1 .72-1l5.09-.61a.87.87 0 0 1 .95.78.88.88 0 0 1-.72 1l-5.1.61a.86.86 0 0 1-.94-.77zm6.7-.78a.77.77 0 0 0-.83-.66l-5.1.61a.75.75 0 0 0-.61.83.79.79 0 0 0 .83.66l5.1-.61a.73.73 0 0 0 .61-.83z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M124.84 338.81a.8.8 0 0 1 .77-.83h11.58a.83.83 0 0 1 0 1.66h-11.58a.8.8 0 0 1-.77-.83z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M124.78 338.81a.87.87 0 0 1 .83-.89h11.58a.89.89 0 0 1 0 1.78h-11.58a.87.87 0 0 1-.83-.89zm13.13.06a.78.78 0 0 0-.72-.78h-11.58a.75.75 0 0 0-.72.78.79.79 0 0 0 .72.77h11.58a.82.82 0 0 0 .72-.77z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M130.99 344.4a.84.84 0 0 1 .83-.77l5.15.39a.8.8 0 0 1 .72.88.84.84 0 0 1-.83.78l-5.15-.39a.89.89 0 0 1-.72-.89z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M130.94 344.4a.91.91 0 0 1 .89-.83l5.15.39a.88.88 0 0 1 .78.94.91.91 0 0 1-.89.83l-5.15-.38a1 1 0 0 1-.78-.95zm6.76.5a.7.7 0 0 0-.66-.77l-5.16-.39a.78.78 0 0 0-.77.72.7.7 0 0 0 .66.78l5.16.38a.82.82 0 0 0 .76-.72z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M123.84 348.45a.86.86 0 0 1 .94-.67l11.36 2.28a.77.77 0 0 1 .61.94.85.85 0 0 1-.94.66l-11.36-2.27a.83.83 0 0 1-.61-.94z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M123.79 348.45a.89.89 0 0 1 1-.72l11.36 2.27a.9.9 0 0 1-.33 1.77l-11.36-2.27a.93.93 0 0 1-.66-1zm12.9 2.6a.78.78 0 0 0-.55-.88l-11.36-2.28a.77.77 0 0 0-.33 1.5l11.36 2.27a.79.79 0 0 0 .88-.61z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M128.83 355.1a.81.81 0 0 1 1-.61l5 1.38a.8.8 0 0 1 .55 1 .82.82 0 0 1-1 .61l-5-1.39a.79.79 0 0 1-.55-1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M128.77 355.1a.83.83 0 0 1 1-.61l5 1.38a.89.89 0 0 1 .61 1.05.83.83 0 0 1-1 .61l-5-1.38a.86.86 0 0 1-.61-1.05zm6.48 1.82a.77.77 0 0 0-.5-.94l-5-1.38a.71.71 0 0 0-.89.55.77.77 0 0 0 .5.94l5 1.39a.8.8 0 0 0 .89-.56z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M121.02 357.76a.79.79 0 0 1 1-.45l10.69 4.43a.84.84 0 0 1 .44 1.06.79.79 0 0 1-1 .44l-10.69-4.43a.79.79 0 0 1-.44-1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M120.94 357.7a.86.86 0 0 1 1.11-.5l10.69 4.43a.89.89 0 0 1 .44 1.17.86.86 0 0 1-1.1.5l-10.7-4.44a.91.91 0 0 1-.44-1.16zm12.13 5a.75.75 0 0 0-.39-1l-10.69-4.43a.73.73 0 0 0-.94.45.75.75 0 0 0 .39 1l10.71 4.44a.73.73 0 0 0 .94-.42z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M124.62 365.23a.83.83 0 0 1 1-.38l4.6 2.32a.81.81 0 0 1 .33 1.11.83.83 0 0 1-1 .39l-4.6-2.33a.82.82 0 0 1-.33-1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M124.56 365.16a.85.85 0 0 1 1.16-.39l4.6 2.33a.87.87 0 0 1-.77 1.55l-4.6-2.33a.83.83 0 0 1-.39-1.16zm6 3.05a.72.72 0 0 0-.33-1l-4.6-2.33a.82.82 0 0 0-1 .33.72.72 0 0 0 .33 1l4.6 2.33a.73.73 0 0 0 1-.33z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M116.47 366.29a.76.76 0 0 1 1.11-.22l9.64 6.42a.79.79 0 0 1 .22 1.11.76.76 0 0 1-1.11.22l-9.64-6.43a.77.77 0 0 1-.22-1.1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M116.42 366.23a1 1 0 0 1 1.22-.28l9.64 6.43a.89.89 0 0 1 .22 1.22 1 1 0 0 1-1.22.28l-9.64-6.43a.84.84 0 0 1-.22-1.22zm10.91 7.31a.78.78 0 0 0-.16-1.05l-9.64-6.42a.71.71 0 0 0-1 .22.78.78 0 0 0 .16 1.05l9.64 6.43a.72.72 0 0 0 1-.23z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M118.52 374.32a.81.81 0 0 1 1.11-.17l4 3.16a.79.79 0 0 1 .12 1.11.81.81 0 0 1-1.11.17l-4.05-3.16a.8.8 0 0 1-.07-1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M118.47 374.26a.88.88 0 0 1 1.22-.16l4 3.16a.87.87 0 1 1-1 1.38l-4.05-3.16a.88.88 0 0 1-.17-1.22zm5.32 4.16a.72.72 0 0 0-.12-1.05l-4-3.16a.79.79 0 0 0-1.05.16.73.73 0 0 0 .11 1.06l4 3.16a.8.8 0 0 0 1.06-.17z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M110.27 373.77a.73.73 0 0 1 1.11 0l8.2 8.14a.8.8 0 0 1 0 1.11.75.75 0 0 1-1.11 0l-8.2-8.15a.83.83 0 0 1 0-1.1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M110.27 373.71a.88.88 0 0 1 1.22 0l8.2 8.14a.863.863 0 0 1-1.22 1.22l-8.2-8.14a.78.78 0 0 1 0-1.22zm9.31 9.25a.78.78 0 0 0 0-1.05l-8.2-8.14a.77.77 0 0 0-1.06 0 .78.78 0 0 0 0 1.05l8.2 8.14a.69.69 0 0 0 1.06 0z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M110.77 382.02a.78.78 0 0 1 1.11.06l3.37 3.87a.81.81 0 0 1-1.21 1.06l-3.38-3.85a.79.79 0 0 1 .11-1.14z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M110.71 382.02a.87.87 0 0 1 1.22.06l3.38 3.87a.83.83 0 0 1-.11 1.22.87.87 0 0 1-1.26-.01l-3.38-3.88a.87.87 0 0 1 .11-1.22zm4.43 5a.76.76 0 0 0 .11-1l-3.38-3.86a.76.76 0 0 0-1.05-.05.78.78 0 0 0-.11 1.05l3.38 3.88a.72.72 0 0 0 1 0z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M102.79 379.91a.76.76 0 0 1 1.15.25l6.42 9.58a.84.84 0 0 1-.22 1.11.76.76 0 0 1-1.11-.22l-6.42-9.59a.86.86 0 0 1 .22-1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M102.79 379.86a.88.88 0 0 1 1.22.22l6.42 9.59a.84.84 0 0 1-.27 1.21.88.88 0 0 1-1.22-.22l-6.43-9.58a.85.85 0 0 1 .28-1.22zm7.31 10.91a.71.71 0 0 0 .22-1l-6.38-9.61a.76.76 0 0 0-1.05-.16.71.71 0 0 0-.23 1l6.43 9.59a.84.84 0 0 0 1 .16z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M101.63 388.16a.8.8 0 0 1 1.1.28l2.55 4.49a.83.83 0 0 1-.33 1.11.81.81 0 0 1-1.11-.28l-2.55-4.49a.89.89 0 0 1 .34-1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M101.63 388.06a.86.86 0 0 1 1.16.27l2.55 4.49a.85.85 0 0 1-.33 1.17.87.87 0 0 1-1.17-.28l-2.55-4.49a.85.85 0 0 1 .34-1.16zm3.32 5.87a.74.74 0 0 0 .28-1l-2.55-4.48a.79.79 0 0 0-1-.28.74.74 0 0 0-.28 1l2.55 4.48a.73.73 0 0 0 1 .28z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M94.26 384.46a.79.79 0 0 1 1.05.39l4.49 10.69a.85.85 0 0 1-.44 1.05.82.82 0 0 1-1.06-.39l-4.48-10.69a.83.83 0 0 1 .44-1.05z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M94.26 384.4a.92.92 0 0 1 1.16.45l4.52 10.69a.85.85 0 0 1-.5 1.1.91.91 0 0 1-1.16-.44l-4.49-10.69a.9.9 0 0 1 .5-1.11zm5 12.13a.71.71 0 0 0 .39-.94l-4.49-10.69a.76.76 0 0 0-1-.39.71.71 0 0 0-.38.94l4.48 10.7a.77.77 0 0 0 1.04.38z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M91.54 392.32a.82.82 0 0 1 1.06.5l1.6 4.88a.78.78 0 0 1-.5 1 .8.8 0 0 1-1-.49l-1.6-4.88a.76.76 0 0 1 .49-1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M91.49 392.27a.86.86 0 0 1 1.11.5l1.6 4.87a.89.89 0 0 1-.55 1.11.87.87 0 0 1-1.11-.5l-1.6-4.87a1 1 0 0 1 .56-1.11zm2.16 6.37a.77.77 0 0 0 .5-.94l-1.61-4.88a.73.73 0 0 0-.94-.44.77.77 0 0 0-.5.94l1.61 4.88a.69.69 0 0 0 .87.46h.07z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M85.01 387.28a.75.75 0 0 1 .94.61l2.33 11.36a.81.81 0 0 1-.67.94.75.75 0 0 1-.94-.61l-2.33-11.36a.89.89 0 0 1 .67-.94z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M85.01 387.23a.89.89 0 0 1 1.05.66l2.33 11.36a.85.85 0 0 1-.67 1 .89.89 0 0 1-1.05-.67l-2.33-11.36a.82.82 0 0 1 .67-1zm2.6 12.9a.76.76 0 0 0 .61-.88l-2.28-11.36a.71.71 0 0 0-.88-.55.76.76 0 0 0-.61.88l2.32 11.36a.81.81 0 0 0 .89.56z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M80.8 394.48a.86.86 0 0 1 .94.67l.66 5.1a.79.79 0 0 1-.72.88.85.85 0 0 1-.94-.66l-.66-5.1a.81.81 0 0 1 .72-.89z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M80.8 394.43a.87.87 0 0 1 1 .72l.67 5.1a.892.892 0 0 1-1.77.22l-.67-5.1a.87.87 0 0 1 .77-.94zm.83 6.65a.78.78 0 0 0 .66-.83l-.66-5.1a.74.74 0 0 0-.83-.61.79.79 0 0 0-.67.83l.67 5.1a.75.75 0 0 0 .83.61z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M75.09 388.28a.81.81 0 0 1 .83.78v11.57a.83.83 0 0 1-1.66 0v-11.57a.85.85 0 0 1 .83-.78z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M75.09 388.22a.87.87 0 0 1 .89.83v11.58a.89.89 0 0 1-1.78 0v-11.57a.91.91 0 0 1 .89-.84zm0 13.13a.78.78 0 0 0 .78-.72v-11.57a.76.76 0 0 0-.78-.73.78.78 0 0 0-.77.73v11.57a.81.81 0 0 0 .77.72z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M69.55 394.48a.85.85 0 0 1 .78.83l-.39 5.16a.81.81 0 0 1-.89.72.84.84 0 0 1-.77-.83l.38-5.16a.82.82 0 0 1 .89-.72z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M69.55 394.43a.89.89 0 0 1 .83.88l-.39 5.16a.86.86 0 0 1-.94.77.89.89 0 0 1-.83-.88l.39-5.16a.83.83 0 0 1 .94-.77zm-.5 6.7a.74.74 0 0 0 .78-.66l.39-5.16a.78.78 0 0 0-.72-.77.74.74 0 0 0-.78.66l-.39 5.16a.82.82 0 0 0 .72.77z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M65.4 387.28a.85.85 0 0 1 .66.94l-2.27 11.36a.77.77 0 0 1-.94.61.85.85 0 0 1-.67-.94l2.28-11.36a.82.82 0 0 1 .94-.61z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M65.4 387.23a.91.91 0 0 1 .72 1l-2.27 11.36a.91.91 0 0 1-1.78-.33l2.27-11.36a1 1 0 0 1 1.06-.66zm-2.61 12.93a.79.79 0 0 0 .89-.55l2.26-11.39a.763.763 0 0 0-1.49-.33l-2.28 11.36a.8.8 0 0 0 .62.91z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M58.75 392.27a.83.83 0 0 1 .61 1l-1.39 5a.79.79 0 0 1-1 .56.83.83 0 0 1-.61-1l1.38-5a.8.8 0 0 1 1-.55z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M58.75 392.21a.85.85 0 0 1 .61 1.06l-1.39 5a.89.89 0 0 1-1 .61.85.85 0 0 1-.61-1.05l1.39-5a.86.86 0 0 1 1-.61zm-1.81 6.48a.76.76 0 0 0 .94-.49l1.39-5a.71.71 0 0 0-.56-.89.77.77 0 0 0-.94.5l-1.38 5a.78.78 0 0 0 .55.88z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M56.03 384.46a.79.79 0 0 1 .45 1.05l-4.43 10.65a.78.78 0 0 1-1.06.39.86.86 0 0 1-.44-1.05l4.39-10.65a.77.77 0 0 1 1-.39z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M56.03 384.4a.86.86 0 0 1 .5 1.11l-4.43 10.65a.87.87 0 0 1-1.16.44.84.84 0 0 1-.5-1.1l4.43-10.69a.86.86 0 0 1 1.16-.41zm-5 12.13a.76.76 0 0 0 1-.38l4.43-10.7a.71.71 0 0 0-.44-.94.76.76 0 0 0-1 .39l-4.43 10.69a.79.79 0 0 0 .4.94z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M48.56 388a.83.83 0 0 1 .38 1.05l-2.32 4.6a.82.82 0 0 1-1.11.34.85.85 0 0 1-.39-1.06l2.33-4.59a.81.81 0 0 1 1.11-.34z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M48.56 387.95a.84.84 0 0 1 .38 1.21l-2.32 4.6a.86.86 0 0 1-1.17.39.84.84 0 0 1-.38-1.17l2.32-4.59a.85.85 0 0 1 1.17-.44zm-3.05 6a.74.74 0 0 0 1-.34l2.32-4.59a.82.82 0 0 0-.33-1 .73.73 0 0 0-1 .33l-2.32 4.6a.82.82 0 0 0 .33 1z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M47.45 379.8a.76.76 0 0 1 .22 1.11l-6.43 9.59a.79.79 0 0 1-1.1.22.77.77 0 0 1-.23-1.11l6.43-9.59a.76.76 0 0 1 1.11-.22z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M47.45 379.75a1 1 0 0 1 .27 1.22l-6.42 9.58a.87.87 0 0 1-1.22.22 1 1 0 0 1-.28-1.22l6.43-9.58a.88.88 0 0 1 1.22-.22zm-7.31 10.91a.78.78 0 0 0 1-.16l6.42-9.59a.71.71 0 0 0-.22-1 .78.78 0 0 0-1 .17l-6.4 9.53a.78.78 0 0 0 .23 1.05z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M39.36 381.85a.81.81 0 0 1 .17 1.11l-3.22 4.05a.81.81 0 0 1-1.27-1l3.21-4.05a.8.8 0 0 1 1.11-.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M39.42 381.8a.88.88 0 0 1 .16 1.22l-3.21 4a.82.82 0 0 1-1.22.11.88.88 0 0 1-.17-1.22l3.22-4a.82.82 0 0 1 1.22-.11zm-4.16 5.26a.72.72 0 0 0 1.05-.11l3.22-4a.8.8 0 0 0-.17-1.06.73.73 0 0 0-1 .11l-3.22 4.05a.78.78 0 0 0 .17 1z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M39.94 373.54a.73.73 0 0 1 0 1.11l-8.19 8.14a.78.78 0 0 1-1.11 0 .77.77 0 0 1 0-1.1l8.14-8.15a.8.8 0 0 1 1.16 0z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M39.94 373.49a.88.88 0 0 1 0 1.22l-8.2 8.14a.863.863 0 1 1-1.22-1.22l8.2-8.14a.88.88 0 0 1 1.22 0zm-9.36 9.3a.76.76 0 0 0 1 0l8.2-8.14a.74.74 0 0 0-1-1.05l-8.2 8.14a.76.76 0 0 0 0 1.05z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M31.6 373.99a.79.79 0 0 1 0 1.11l-3.93 3.32a.84.84 0 0 1-1.11-1.26l3.94-3.32a.77.77 0 0 1 1.1.15z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M31.66 373.93a.86.86 0 0 1-.06 1.22l-3.93 3.32a.82.82 0 0 1-1.22-.11.87.87 0 0 1 .06-1.22l3.93-3.32a.83.83 0 0 1 1.22.11zm-5.1 4.38a.79.79 0 0 0 1.06.11l3.93-3.32a.77.77 0 0 0-1-1.17l-3.93 3.33a.72.72 0 0 0-.06 1z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M33.82 366.01a.75.75 0 0 1-.22 1.11l-9.66 6.42a.84.84 0 0 1-1.11-.22.76.76 0 0 1 .22-1.11l9.64-6.42a.88.88 0 0 1 1.11.22z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M33.88 366.01a.89.89 0 0 1-.23 1.22l-9.64 6.42a.84.84 0 0 1-1.21-.27.88.88 0 0 1 .22-1.22l9.64-6.43a.86.86 0 0 1 1.22.28zm-11 7.26a.72.72 0 0 0 1 .22l9.64-6.43a.71.71 0 0 0 .17-1 .73.73 0 0 0-1-.22l-9.64 6.42a.8.8 0 0 0-.16 1.06z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M25.57 364.85a.8.8 0 0 1-.28 1.1l-4.49 2.55a.83.83 0 0 1-1.11-.33.81.81 0 0 1 .25-1.11l4.49-2.55a.83.83 0 0 1 1.11.34z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M25.62 364.79a.86.86 0 0 1-.28 1.16l-4.48 2.55a.9.9 0 0 1-1.17-.33.86.86 0 0 1 .28-1.16l4.49-2.55a.88.88 0 0 1 1.16.33zm-5.87 3.37a.7.7 0 0 0 1 .27l4.48-2.55a.77.77 0 0 0 .28-1 .7.7 0 0 0-1-.28l-4.48 2.56a.75.75 0 0 0-.28 1z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M29.28 357.48a.77.77 0 0 1-.45 1.05l-10.69 4.43a.83.83 0 0 1-1-.44.77.77 0 0 1 .44-1.05l10.7-4.43a.79.79 0 0 1 1 .44z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M29.33 357.42a.92.92 0 0 1-.44 1.17l-10.69 4.43a.86.86 0 0 1-1.11-.5.91.91 0 0 1 .44-1.16l10.7-4.44a.86.86 0 0 1 1.1.5zm-12.13 5a.79.79 0 0 0 .94.45l10.69-4.43a.75.75 0 0 0 .39-1 .77.77 0 0 0-.94-.44l-10.69 4.43a.74.74 0 0 0-.39 1z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M21.47 354.71a.81.81 0 0 1-.5 1.05l-4.88 1.61a.78.78 0 0 1-1-.5.79.79 0 0 1 .49-1l4.88-1.61a.77.77 0 0 1 1.01.45z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M21.52 354.65a.84.84 0 0 1-.58 1.11l-4.88 1.61a.9.9 0 0 1-1.11-.56.84.84 0 0 1 .56-1.1l4.87-1.61a.94.94 0 0 1 1.11.55zm-6.42 2.11a.77.77 0 0 0 .94.5l4.9-1.61a.74.74 0 0 0 .45-.94.78.78 0 0 0-1-.5l-4.87 1.61a.76.76 0 0 0-.42.94z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M26.45 348.16a.75.75 0 0 1-.61.94l-11.35 2.21a.81.81 0 0 1-1-.66.75.75 0 0 1 .61-.94l11.36-2.22a.82.82 0 0 1 .94.67z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M26.56 348.16a.89.89 0 0 1-.62 1l-11.4 2.22a.86.86 0 0 1-1-.72.9.9 0 0 1 .67-1.05l11.36-2.21a.85.85 0 0 1 .99.76zm-12.9 2.49a.74.74 0 0 0 .83.61l11.35-2.22a.72.72 0 0 0 .56-.88.74.74 0 0 0-.83-.61l-11.36 2.21a.74.74 0 0 0-.55.89z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M19.36 343.85a.77.77 0 0 1-.66.89l-5.1.61a.82.82 0 0 1-.89-.72.78.78 0 0 1 .67-.89l5.1-.61a.84.84 0 0 1 .88.72z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M19.42 343.85a.89.89 0 0 1-.72 1l-5.1.61a.87.87 0 0 1-.94-.78.89.89 0 0 1 .72-1l5.1-.6a.86.86 0 0 1 .94.77zm-6.71.78a.79.79 0 0 0 .83.66l5.1-.61a.73.73 0 0 0 .61-.83.77.77 0 0 0-.83-.66l-5.1.61a.75.75 0 0 0-.61.83z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M25.57 338.48a.81.81 0 0 1-.78.83H13.21a.83.83 0 0 1 0-1.66h11.58a.81.81 0 0 1 .78.83z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M25.62 338.48a.86.86 0 0 1-.83.88H13.21a.86.86 0 0 1-.83-.88.87.87 0 0 1 .83-.89h11.58a.87.87 0 0 1 .83.89zm-13.13-.06a.78.78 0 0 0 .72.78h11.58a.74.74 0 0 0 .72-.78.78.78 0 0 0-.72-.77H13.21a.81.81 0 0 0-.72.77z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M19.42 332.88a.85.85 0 0 1-.83.78l-5.16-.39a.81.81 0 0 1-.72-.89.84.84 0 0 1 .83-.77l5.16.39a.9.9 0 0 1 .72.88z",
    fill: "#e2e2e2"
  }), React.createElement("path", {
    d: "M19.47 332.88a.89.89 0 0 1-.88.83l-5.16-.38a.87.87 0 0 1-.77-.95.9.9 0 0 1 .88-.83l5.16.39a1 1 0 0 1 .77.94zm-6.76-.5a.71.71 0 0 0 .67.78l5.15.39a.79.79 0 0 0 .78-.72.71.71 0 0 0-.67-.78l-5.15-.39a.84.84 0 0 0-.78.72z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M26.56 328.84a.85.85 0 0 1-.94.66l-11.36-2.34a.77.77 0 0 1-.6-.95.84.84 0 0 1 .94-.66l11.34 2.29a.92.92 0 0 1 .61 1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M26.62 328.84a.91.91 0 0 1-1 .72l-11.36-2.27a.9.9 0 0 1-.66-1.06.91.91 0 0 1 1-.72l11.34 2.28a.94.94 0 0 1 .67 1.05zm-12.91-2.61a.81.81 0 0 0 .55.89l11.36 2.27a.78.78 0 0 0 .89-.61.79.79 0 0 0-.56-.88l-11.35-2.27a.8.8 0 0 0-.89.6z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M21.58 322.16a.83.83 0 0 1-1 .61l-5-1.39a.79.79 0 0 1-.55-1 .82.82 0 0 1 1-.61l5 1.38a.8.8 0 0 1 .56 1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M21.63 322.16a.84.84 0 0 1-1 .61l-5-1.39a.88.88 0 0 1-.69-1.02.86.86 0 0 1 1.06-.61l5 1.39a.85.85 0 0 1 .61 1zm-6.48-1.83a.77.77 0 0 0 .5.94l5 1.39a.7.7 0 0 0 .88-.56.77.77 0 0 0-.5-.94l-5-1.38a.79.79 0 0 0-.89.55z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M29.39 319.53a.79.79 0 0 1-1 .44l-10.7-4.43a.84.84 0 0 1-.44-1.05.79.79 0 0 1 1-.44l10.69 4.43a.79.79 0 0 1 .44 1.05z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M29.44 319.59a.86.86 0 0 1-1.1.5l-10.7-4.44a.9.9 0 0 1 .67-1.66L29 318.42a.92.92 0 0 1 .44 1.17zm-12.13-5a.75.75 0 0 0 .39 1l10.69 4.43a.71.71 0 0 0 .94-.44.76.76 0 0 0-.38-1l-10.7-4.43a.74.74 0 0 0-.94.45z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M25.79 312.05a.83.83 0 0 1-1 .39l-4.65-2.28a.79.79 0 0 1-.34-1.1.84.84 0 0 1 1.06-.39l4.59 2.32a.83.83 0 0 1 .34 1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M25.84 312.16a.85.85 0 0 1-1.16.39l-4.6-2.39a.87.87 0 1 1 .78-1.55l4.59 2.32a.84.84 0 0 1 .39 1.23zm-6-3.05a.73.73 0 0 0 .33 1l4.6 2.33a.83.83 0 0 0 1-.34.73.73 0 0 0-.33-1l-4.66-2.33a.68.68 0 0 0-.94.33z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M33.94 311a.76.76 0 0 1-1.11.22l-9.58-6.37a.79.79 0 0 1-.22-1.11.75.75 0 0 1 1.11-.22l9.63 6.43a.72.72 0 0 1 .17 1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M33.99 311.06a1 1 0 0 1-1.22.27l-9.59-6.42a.89.89 0 0 1-.22-1.22 1 1 0 0 1 1.22-.28l9.58 6.43a.84.84 0 0 1 .23 1.22zm-10.92-7.32a.79.79 0 0 0 .17 1.06l9.64 6.42a.73.73 0 0 0 1-.22.78.78 0 0 0-.17-1l-9.64-6.43a.73.73 0 0 0-1 .22z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M31.88 302.97a.8.8 0 0 1-1.11.16l-4-3.15a.79.79 0 0 1-.11-1.11.8.8 0 0 1 1.11-.17l4 3.16a.79.79 0 0 1 .11 1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M31.94 303.02a.87.87 0 0 1-1.22.17l-4-3.16a.87.87 0 0 1 1.06-1.38l4 3.15a.88.88 0 0 1 .17 1.22zm-5.32-4.15a.72.72 0 0 0 .11 1.05l4 3.16a.8.8 0 0 0 1.06-.17.73.73 0 0 0-.11-1.05l-4-3.16a.79.79 0 0 0-1 .17z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M40.13 303.52a.73.73 0 0 1-1.1 0l-8.26-8.14a.8.8 0 0 1 0-1.11.75.75 0 0 1 1.11 0l8.2 8.14a.8.8 0 0 1 .06 1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M40.13 303.58a.86.86 0 0 1-1.21 0l-8.2-8.15a.86.86 0 0 1 0-1.22.88.88 0 0 1 1.22 0l8.19 8.15a.78.78 0 0 1 0 1.22zm-9.3-9.26a.77.77 0 0 0 0 1.06l8.2 8.14a.74.74 0 1 0 1-1.05l-8.2-8.2a.71.71 0 0 0-1 .06z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M39.64 295.27a.8.8 0 0 1-1.11-.06l-3.38-3.88a.78.78 0 0 1 .11-1.1.79.79 0 0 1 1.11.05l3.38 3.88a.81.81 0 0 1-.11 1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M39.69 295.27a.88.88 0 0 1-1.22-.06l-3.38-3.88a.82.82 0 0 1 .12-1.21.85.85 0 0 1 1.21.05l3.38 3.88a.87.87 0 0 1-.11 1.22zm-4.43-5a.78.78 0 0 0-.11 1.05l3.38 3.84a.77.77 0 0 0 1.16-1l-3.38-3.88a.72.72 0 0 0-1.05-.05z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M47.61 297.37a.74.74 0 0 1-1.1-.22l-6.49-9.58a.84.84 0 0 1 .23-1.11.74.74 0 0 1 1.1.22l6.43 9.58a.78.78 0 0 1-.17 1.11z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M47.61 297.43a.9.9 0 0 1-1.22-.22l-6.45-9.59a.85.85 0 0 1 .28-1.22.9.9 0 0 1 1.22.23l6.42 9.58a.84.84 0 0 1-.25 1.22zm-7.31-10.92a.73.73 0 0 0-.22 1l6.43 9.59a.77.77 0 0 0 1.05.16.73.73 0 0 0 .22-1l-6.43-9.52a.78.78 0 0 0-1-.23z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M48.78 289.16a.81.81 0 0 1-1.11-.27l-2.55-4.49a.83.83 0 0 1 .33-1.11.81.81 0 0 1 1.11.28l2.55 4.49a.86.86 0 0 1-.33 1.1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M48.78 289.23a.87.87 0 0 1-1.17-.28l-2.54-4.49a.83.83 0 0 1 .33-1.16.86.86 0 0 1 1.16.28l2.55 4.49a.85.85 0 0 1-.33 1.16zm-3.33-5.87a.73.73 0 0 0-.27 1l2.55 4.49a.8.8 0 0 0 1 .28.75.75 0 0 0 .28-1l-2.55-4.49a.72.72 0 0 0-1-.27z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M56.14 292.83a.79.79 0 0 1-1-.39l-4.48-10.69a.83.83 0 0 1 .44-1 .79.79 0 0 1 1 .38l4.49 10.7a.85.85 0 0 1-.45 1.05z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M56.14 292.89a.92.92 0 0 1-1.16-.45l-4.49-10.69a.87.87 0 0 1 .5-1.11.93.93 0 0 1 1.17.45l4.48 10.69a.91.91 0 0 1-.49 1.11zm-5-12.14a.71.71 0 0 0-.38.94l4.48 10.7a.76.76 0 0 0 1 .38.71.71 0 0 0 .39-.94l-4.53-10.67a.78.78 0 0 0-1-.39z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M58.86 284.96a.79.79 0 0 1-1-.5l-1.61-4.87a.78.78 0 0 1 .5-1 .87.87 0 0 1 1 .5l1.61 4.88a.76.76 0 0 1-.5 1z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M58.94 285.02a.85.85 0 0 1-1.1-.5l-1.61-4.88a.87.87 0 0 1 .56-1.1.85.85 0 0 1 1.1.5l1.61 4.87a1 1 0 0 1-.56 1.11zm-2.16-6.37a.76.76 0 0 0-.49.94l1.6 4.87a.74.74 0 0 0 .94.45.77.77 0 0 0 .5-.94l-1.6-4.88a.7.7 0 0 0-.87-.47h-.08z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M65.4 290a.73.73 0 0 1-.94-.61l-2.33-11.35a.81.81 0 0 1 .66-.94.74.74 0 0 1 .94.61l2.33 11.35a.88.88 0 0 1-.66.94z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M65.4 290.06a.9.9 0 0 1-1.06-.67l-2.32-11.35a.84.84 0 0 1 .66-1 .89.89 0 0 1 1.05.67l2.33 11.35a.82.82 0 0 1-.66 1zm-2.61-12.9a.78.78 0 0 0-.61.89l2.33 11.36a.73.73 0 0 0 .89.55.78.78 0 0 0 .61-.89l-2.33-11.35a.8.8 0 0 0-.89-.56z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M69.61 282.8a.86.86 0 0 1-.95-.66l-.66-5.1a.81.81 0 0 1 .72-.89.86.86 0 0 1 .94.67l.67 5.1a.81.81 0 0 1-.72.88z",
    fill: "#f3f3f3"
  }), React.createElement("path", {
    d: "M69.61 282.86a.89.89 0 0 1-1-.72l-.67-5.1a.87.87 0 0 1 .78-.94.89.89 0 0 1 1 .72l.66 5.1a.86.86 0 0 1-.77.94zm-.83-6.65a.79.79 0 0 0-.67.83l.67 5.1a.74.74 0 0 0 .83.61.79.79 0 0 0 .66-.83l-.66-5.1a.74.74 0 0 0-.83-.61z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 75.59,
    cy: 338.59,
    r: 65.59,
    fillOpacity: 0.2,
    fill: "url(#prefix__e)"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M121.01 296.99l-52.9 33.9h-.06v.06L68 331l-33.02 54.46 48.53-39.06.05-.05v-.06l37.45-49.3z"
  }), React.createElement("path", {
    d: "M120.02 293.83L67.72 331l15.51 15.4 36.79-52.57",
    fill: "#cd151e"
  }), React.createElement("path", {
    d: "M67.78 330.89l7.81 7.7 44.43-44.76-52.24 37.06z",
    fill: "#fa5153"
  }), React.createElement("path", {
    d: "M67.78 330.89l15.51 15.4-52.3 37.17 36.79-52.57z",
    fill: "#acacac"
  }), React.createElement("path", {
    d: "M30.99 383.46l44.6-44.87-7.81-7.7-36.79 52.57z",
    fill: "#eee"
  })), React.createElement("ellipse", {
    cx: 125.37,
    cy: 805.65,
    rx: 113.45,
    ry: 12.53,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 535.88,
    cy: 548.39,
    rx: 79.91,
    ry: 11.03,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M332.47 485.89v-.07l-.09-.06-.54-.37.11.09a1.79 1.79 0 0 0-2.36.51l-.22.32-12.15 17.47-2.13 3.06c-6.41-1.93-16.82 6.2-22.09 10.85l-.93.82c-.41-.94-.66-1.53-.66-1.53-.26 2.86-10.36 7.14-12.72 8.7a8.66 8.66 0 0 1-3.52 1.19c.33-10.88-8.07-22.32-8.07-22.32l-20.5-26.15a23.08 23.08 0 0 1 2.1-13.87c.17-.34.34-.67.53-1h.1a22.79 22.79 0 0 0-1.29 6.83c.05 1.78 1.69 10.35 4 10a1.25 1.25 0 0 0 1.18-.57c1.84-2.14 2-5.78 1.91-9.15a18.62 18.62 0 0 1-.33 2.95c.15-2.8-.17-5.76-.17-7.87 0-.84 0-1.67.06-2.51h.25v0h.27a27.59 27.59 0 0 0 12.55-5.81 6.77 6.77 0 0 0 4.72-2.21 4.59 4.59 0 0 1-.89 4.27c2.75-.13 5.08-2.27 6.14-4.78a16.68 16.68 0 0 0 .78-8 55.49 55.49 0 0 1-.59-8.13 29.77 29.77 0 0 0 .24-4.42 8.67 8.67 0 0 0-.24-1.35h.08a1.89 1.89 0 0 0 1.43-.55c1.14-.88 1.51-2.61 1.8-3.92a33.42 33.42 0 0 0 1.06-9.31c-.06.95-.18 1.9-.32 2.85.25-3.6-.25-7.1-2.63-9.7-1.64-1.8-3.93-2.85-6.13-3.89a4.74 4.74 0 0 1-2-1.43 5.93 5.93 0 0 1-.61-2.48c-.77-5.27-5.72-8.92-10.65-11.06-6.34-2.75-14-3.94-20.05-.66-3 1.59-5.3 4.09-8 6.12-3.38 2.56-7.28 4.36-10.89 6.6s-7.05 5.08-8.77 8.94c-2.65 6-.66 12.81-.33 19.31.53 10.25-3.69 21-12.05 27a10.84 10.84 0 0 0-2.65 2.29 2.86 2.86 0 0 0-.22 3.27c.43.57 1.11.88 1.58 1.41.95 1.09.76 2.73.39 4.12a25.79 25.79 0 0 1-7 11.85c.15 1.07 1.46 1.49 2.53 1.64a56.91 56.91 0 0 0 8.55.62h1.23c-.13.33-.27.68-.41 1-1.55 4.09-3.56 10.36-2.89 14.2 1.05 6.07 4.2 33.78 2.62 38.63s2.45 40.35 2.45 40.35.55 2.72 1.5 6.78c-2.47 5.83-5.29 12.28-6.7 14.87-2.84 5.2-1.44 31.7 8.35 43.47 0 0 4.05 5.72 3 7.8s.18 5.71.18 5.71l1.55 34.3a87.57 87.57 0 0 1-.73 10.47c-4.17 5.17-10.61 12.71-13.64 14-4.69 1.9-39.67 44.33-39.67 44.33s.28.51.82 1.35l-1 1.13-6.71 7.78-.53.61c-1.26-.23-9.65-1.76-16.3-2.24h-.66V770a24.88 24.88 0 0 0-7 .19 2.26 2.26 0 0 0-1.16.61c-2.27 2.77-3.49 46.42-3.49 46.42s2.42 21.84 10 23.06a4.4 4.4 0 0 0 1.2.23 3 3 0 0 0 .42 0 10.31 10.31 0 0 0 9-5.61 9.34 9.34 0 0 0 .75-2s-.88-3.9 1.48-9.27 6.74-14.72 6.74-14.72 8-8.4 6.56-12.49l.77-1.1c3-4.27 9.08-12.72 14-18.37l1-1.08a25.16 25.16 0 0 0 5.57 1.62s7.53-3 10.32-9.53c1.19-2.8 5.86-7.75 10.83-12.53l-.16 1.28-.17 41.73a29 29 0 0 0 5.14 2.83v1a134.26 134.26 0 0 1-1.08 17.8l-.15.92c-.62-.44-1.16-.59-1.5-.24-1.54 1.55-2.5 11.52-2.59 16.1v.46c-.25 4.59-2.86 11.24 5 11.58 5.88.25 31.22.64 44.79.83a30 30 0 0 0 20-7.09c4.31-3.69 6.92-8.08 1-11.31-.36-.19-.74-.38-1.16-.57l-13-2-22.21-11.34s-.13-6.86-2.8-5.72a7.39 7.39 0 0 0-2.25.9c-.13-.26-.27-.52-.4-.8a25.59 25.59 0 0 1-2.74-11.56v-1.11a19.5 19.5 0 0 0 1.84-1.89s-.17-15.58 1.58-18.53 7.19-32.7 7.19-32.7.17-5.55 3.67-8.84 2.27-12.82 2.27-12.82 4.9-2.59 6.47-11.08 6.65-27 6.65-27 10.49-27.36 9.8-44.68 1.05-26.33 1.05-26.33l2.18-40.25v-.62c.87.67 1.46 1.2 1.46 1.2v-.43c.32.26.5.43.5.43s1.12-18.26.74-25.5c6.12-2.08 15.44-5.5 16-7.23.79-2.6 11.29-10.78 11.29-10.78a1.94 1.94 0 0 1-.64-.24c.33-.16.67-.33 1-.53 6.88-3.68 19.66-14.44 17.51-21l14-20.08a3.42 3.42 0 0 0-.3-4.33z",
    transform: "translate(-61.06 -34.84)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M238.83 499.58a9.12 9.12 0 0 1-3.35 1.27c-4.37.13-8-11.71-8-11.71s1.24-1.26 3.22-3c5.86-5.21 18.15-14.84 23.91-9.45 6.5 6.01-8.25 18.82-15.78 22.89zM172.42 781.71l-16.13 17.45s-14.92.17-12-8.06a30.17 30.17 0 0 0 1.24-5.47 134.75 134.75 0 0 0 1-17.62c0-3.87-.06-6.57-.06-6.57s23.49-10.29 21.09.42a20.15 20.15 0 0 0-.48 4.08 27.47 27.47 0 0 0 5.29 15.82z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M172.42 781.71l-16.13 17.45s-14.92.17-12-8.06a30.17 30.17 0 0 0 1.24-5.47c2.13 1.64 5.19 6.5 5.19 6.5s10.29 3 13.12-6c1.58-5 4.08-7.53 6-8.74a25.78 25.78 0 0 0 2.58 4.32z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M209.82 807.92a29.29 29.29 0 0 1-19.64 7c-13.3-.19-38.15-.57-43.92-.82-7.72-.33-5.16-6.92-4.91-11.47v-.45c.09-4.54 1-14.41 2.54-15.95s6.81 6.86 6.81 6.86 10.29 3 13.12-6 8.58-9.86 8.58-9.86c2.61-1.13 2.74 5.66 2.74 5.66l21.8 11.27 12.77 2c.42.19.79.38 1.14.57 5.76 3.19 3.2 7.53-1.03 11.19z",
    fill: "#c17174"
  }), React.createElement("circle", {
    cx: 169.58,
    cy: 789.69,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 178.41,
    cy: 794.06,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 182.96,
    cy: 796.1,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 192.39,
    cy: 799.72,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 187.59,
    cy: 798.17,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M209.82 807.92a29.29 29.29 0 0 1-19.64 7c-13.3-.19-38.15-.57-43.92-.82-7.72-.33-5.16-6.92-4.91-11.47l48.47 3s19.85-3 21-8.92c5.79 3.21 3.23 7.55-1 11.21z",
    fill: "#c17174"
  }), React.createElement("path", {
    d: "M209.82 807.92a29.29 29.29 0 0 1-19.64 7c-13.3-.19-38.15-.57-43.92-.82-7.72-.33-5.16-6.92-4.91-11.47l48.47 3s19.85-3 21-8.92c5.79 3.21 3.23 7.55-1 11.21z",
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M119.59 737.98a32.8 32.8 0 0 0-4.86 4.87c-4.81 5.59-10.76 13.95-13.71 18.19-1.14 1.64-1.83 2.66-1.83 2.66l-6.44-.94s-6.94-10.6-6.81-10.89 5.49-11.66 5.49-11.66l2.09-2.45 6.58-7.7 3-3.49s22.32 7.2 16.49 11.41z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M101.02 761.04c-1.14 1.64-1.83 2.66-1.83 2.66l-6.44-.94s-6.94-10.6-6.81-10.89 5.49-11.66 5.49-11.66l2.09-2.45.68.12h1.63c-5.74 6 .43 19.21.43 19.21s2.68.25 4.76 3.95z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M93.83 774.49s-4.3 9.26-6.61 14.58-1.46 9.17-1.46 9.17a9 9 0 0 1-.73 2 10.12 10.12 0 0 1-8.78 5.55 3 3 0 0 1-.42 0c-7.82-.21-10.3-22.9-10.3-22.9s1.2-43.22 3.43-46a2.21 2.21 0 0 1 1.13-.6 24.41 24.41 0 0 1 6.85-.13c7.07.51 16.16 2.25 16.16 2.25h1.63c-5.75 6 .42 19.2.42 19.2s2.75.26 4.89 4.12-6.21 12.76-6.21 12.76z",
    fill: "#c17174"
  }), React.createElement("circle", {
    cx: 84.38,
    cy: 761.65,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 83.92,
    cy: 769.13,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M84.39 800.08a10.11 10.11 0 0 1-8.78 5.55 2.84 2.84 0 0 1-.41 0c-7.82-.21-10.31-22.9-10.31-22.9s1.2-43.22 3.43-46a2.21 2.21 0 0 1 1.13-.6 24.41 24.41 0 0 1 6.89-.18c-.13 7.76-.5 32.32 0 34.75s4.94 22.84 8.05 29.38z",
    fill: "#c17174"
  }), React.createElement("path", {
    d: "M84.39 800.08a10.11 10.11 0 0 1-8.78 5.55 2.84 2.84 0 0 1-.41 0c-7.82-.21-10.31-22.9-10.31-22.9s1.2-43.22 3.43-46a2.21 2.21 0 0 1 1.13-.6 24.41 24.41 0 0 1 6.89-.18c-.13 7.76-.5 32.32 0 34.75s4.94 22.84 8.05 29.38z",
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M75.2 805.64c-7.82-.21-10.31-22.9-10.31-22.9s1.2-43.22 3.43-46a2.21 2.21 0 0 1 1.13-.6c1.64 2.45 3.08 7.84 1.78 19.73-2.44 22.51.5 23.92.5 23.92s3.65 19.13 3.47 25.85z",
    fill: "#c17174"
  }), React.createElement("path", {
    d: "M75.2 805.64c-7.82-.21-10.31-22.9-10.31-22.9s1.2-43.22 3.43-46a2.21 2.21 0 0 1 1.13-.6c1.64 2.45 3.08 7.84 1.78 19.73-2.44 22.51.5 23.92.5 23.92s3.65 19.13 3.47 25.85zM238.83 499.58a9.12 9.12 0 0 1-3.35 1.27c-4.37.13-8-11.71-8-11.71s1.24-1.26 3.22-3c1.43 3.2 5.37 11.84 8.13 13.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M210.79 495.32s3.6.25 5.91-1.29 12.22-5.79 12.48-8.62c0 0 5.91 14.41 9.26 14.92 0 0-10.29 8.1-11.06 10.68s-20.84 8.87-20.84 8.87z",
    fill: "#9f9eff"
  }), React.createElement("path", {
    d: "M210.79 495.32s3.6.25 5.91-1.29 12.22-5.79 12.48-8.62c0 0 5.91 14.41 9.26 14.92 0 0-10.29 8.1-11.06 10.68s-20.84 8.87-20.84 8.87zM119.59 737.98a32.8 32.8 0 0 0-4.86 4.87c-7.76-3.25-12.76-9.88-14.67-12.79l3-3.49s22.36 7.2 16.53 11.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M156.29 665.01s-12.58 16.8-17.18 18.69-38.89 43.9-38.89 43.9 7.37 13.55 20.92 15.78c0 0 7.37-2.92 10.12-9.43s24.35-24.87 24.35-24.87z",
    fill: "#5e5a6b"
  }), React.createElement("path", {
    d: "M156.29 665.01s-12.58 16.8-17.18 18.69-38.89 43.9-38.89 43.9 7.37 13.55 20.92 15.78c0 0 7.37-2.92 10.12-9.43s24.35-24.87 24.35-24.87z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M118.18 721.3a54.84 54.84 0 0 0 11.45 0c6.81-.64 1.67 3.47-11.45 0zM115.09 725.67s9 5.15 12.48 2.57-3.35 2.48-12.48-2.57zM167.61 761.81a20.15 20.15 0 0 0-.48 4.08c-6.95 6.32-15.32 4.37-20.55 2.07 0-3.87-.06-6.57-.06-6.57s23.49-10.29 21.09.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M209.28 538.1l-.25 4.75-2.09 39.84s-1.72 8.92-1 26.07-9.61 44.24-9.61 44.24-5 18.35-6.52 26.75-6.34 11-6.34 11 1.2 9.43-2.23 12.69-3.6 8.75-3.6 8.75-5.32 29.49-7 32.41-1.7 18.33-1.7 18.33c-11.1 13.23-27.39 1.23-27.39 1.23l.17-41.33s4.63-38.07 8.06-43.39 3.43-19.89 3.43-19.89l-1.53-34s-1.22-3.61-.17-5.66-2.94-7.72-2.94-7.72c-9.6-11.66-11-37.9-8.18-43s11.12-25.72 11.12-25.72l11.43-6.72 20.73.62z",
    fill: "#5e5a6b"
  }), React.createElement("path", {
    d: "M160.5 740.21s2.71 9.38 4.89 10.41-4.89-10.41-4.89-10.41zM164.23 708.95s7 5.55 10 5.53-10-5.53-10-5.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M206.54 476.79v11.37l-7.47-3.22-7.45-3.21-16.21-15.95s-12.82-8.33-19.68-15.92c-3.92-4.33-5.89-8.42-2.44-10.57a21.82 21.82 0 0 0 4.49-3.94 74.09 74.09 0 0 0 8.94-13.19l.32-.58c3.34-6.13 5.55-11.36 5.55-11.36s9.39 3 15.44 7.28c.49.34.95.69 1.39 1 3.37 2.77 5.05 6 1.94 9.16a25 25 0 0 0-2.21 2.65 20.69 20.69 0 0 0-1.38 2.17c-.18.33-.36.67-.52 1a23.06 23.06 0 0 0-2.06 13.73z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M205.17 396.01c.39.67.93 1.25 1.29 1.94a9.41 9.41 0 0 1 .57 4.81 27 27 0 0 0 .5 7.66c.53 2.25 1.52 4.43 1.6 6.75.11 3.28-1.59 6.3-3.24 9.13a6.59 6.59 0 0 0 4.71-2.19 4.55 4.55 0 0 1-.86 4.23c2.69-.12 5-2.24 6-4.73a16.49 16.49 0 0 0 .77-8 54.4 54.4 0 0 1-.58-8.05 29.23 29.23 0 0 0 .23-4.38c-.25-2.92-2-5.44-3.76-7.81l-3.46-4.73a2.49 2.49 0 0 0-1-.92c-3.31-1.39-3.69 4.68-2.77 6.29z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M191.36 427.66a25 25 0 0 0-2.21 2.65 20.69 20.69 0 0 0-1.38 2.17c-.18.33-.36.67-.52 1a26.94 26.94 0 0 1-20.21-10.92l-.32-.45.32-.58c3.34-6.13 5.55-11.36 5.55-11.36s9.39 3 15.44 7.28c.49.34.95.69 1.39 1 3.37 2.82 5.05 6.02 1.94 9.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M215.78 405.49a27 27 0 0 1-22.11 26.57 28.26 28.26 0 0 1-4.9.44h-1a27 27 0 1 1 28-27z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M192.31 472.25s13.6 7.68 10.11 1.2l-17.74-26.24 20.15 25.95s12.86 17.66 5.83 29.84c0 0-1 10.12.17 12.52s-.35 28-.35 28-4.8-4.46-7.37-3.6-20.75 2.4-20.75 2.4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M209.28 538.1l-.25 4.75c-1.63-1.19-3.9-2.51-5.41-2-2.57.86-20.75 2.4-20.75 2.4l.84-5.9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M192.82 472.25s13.61 7.68 10.12 1.2l-17.75-26.24 20.15 25.95s12.86 17.66 5.83 29.84c0 0-1 10.12.17 12.52s-.34 28-.34 28-4.8-4.46-7.37-3.6-20.76 2.4-20.76 2.4z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M200.09 485.41c-.79 8.24-4.18 18-4.18 18s-2.4 24.36-5.49 31.56-1.72 17.15-3.43 35.5c-.62 6.6-2.75 11.14-5.62 14.21-4.72 5-11.46 6.08-16.78 5.77-.44 0-.85-.05-1.27-.09-8.57-.86-16.8-42.19-16.8-42.19s-3.94-35.15-2.4-39.95-1.54-32.25-2.57-38.25c-.66-3.8 1.31-10 2.83-14.06.89-2.34 1.62-3.95 1.62-3.95s2.92-9.26 7.72-14.06a7 7 0 0 1 5.09-2.13 12.56 12.56 0 0 1 6.35 2l.22.14s31.22 31.9 34.13 39.27c.81 2.1.89 5.05.58 8.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M199.07 484.89c-.8 8.24-4.19 18.06-4.19 18.06s-2.4 24.35-5.49 31.55-1.72 17.15-3.43 35.5c-.62 6.61-2.75 11.15-5.62 14.21-4.72 5-11.46 6.09-16.78 5.78l-1.26-.1c-8.58-.85-16.81-42.19-16.81-42.19s-3.94-35.15-2.4-39.95-1.54-32.24-2.57-38.25c-.66-3.8 1.31-10 2.83-14.06.89-2.33 1.62-3.94 1.62-3.94s2.92-9.26 7.72-14.06a7.08 7.08 0 0 1 5.09-2.14 12.62 12.62 0 0 1 6.35 2 1.77 1.77 0 0 1 .22.15s31.22 31.89 34.13 39.27c.81 2.05.89 4.99.59 8.17z",
    fill: "#9f9eff"
  }), React.createElement("path", {
    d: "M164.1 610.43s-7.08 6.3-9.52 6 9.52-6 9.52-6zM165.94 616.48s-7.46 3.47-9.69 4 6.85-4.89 9.69-4zM194.84 521.81s11.06.13 12.73 3.6-9.13-5.01-12.73-3.6zM193.29 527.86s8.49 1.8 11.06 3.85-11.06-3.85-11.06-3.85zM179.02 506.89s-1 34.86-4.82 39.36 4.82-39.36 4.82-39.36zM169.5 605.41s-7.06 30.75 7.14 32.67 9.84-35 9.84-35z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M168.94 604.9s-7.06 30.74 7.15 32.67 9.83-35 9.83-35z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M215.61 402.51a10.08 10.08 0 0 1-1-1.87c-1.89-3.93-6.75-2-10.31-.13-.63.82-1.27 1.63-1.91 2.45a15.25 15.25 0 0 0-2.17 3.35 25.93 25.93 0 0 0-.91 3c-.49 1.75-1.21 3.41-1.86 5.1a59.35 59.35 0 0 0-3.81 17.65 28.26 28.26 0 0 1-4.9.44h-.12v-.13c.18-.68.33-1.37.47-2.06a35.75 35.75 0 0 0 .27-11.81v-.25c-.13-.88-.3-1.75-.37-2.63l-1 1.83c-2.15 4-4.41 8-8.47 9.75a17.38 17.38 0 0 1-5.15 1.17 28.8 28.8 0 0 0-6.44 1.07 4 4 0 0 0-1.87 1.12 5.55 5.55 0 0 0-.94 2.82 22.49 22.49 0 0 1-1 3.91 34.19 34.19 0 0 1-8.4 12.52l-.94.91a17.23 17.23 0 0 1-5.55 3.84 17 17 0 0 1-5.89.88c.89-2.33 1.62-3.94 1.62-3.94s2.92-9.26 7.72-14.06a7.08 7.08 0 0 1 5.09-2.14 75.19 75.19 0 0 0 9.26-13.77 27 27 0 1 1 48.57-19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M217.33 381.44c-1.6-1.78-3.85-2.82-6-3.85a4.49 4.49 0 0 1-1.95-1.42 5.94 5.94 0 0 1-.6-2.45c-.75-5.22-5.61-8.83-10.44-10.95-6.22-2.72-13.69-3.89-19.66-.65-2.9 1.57-5.19 4.05-7.81 6.05-3.32 2.55-7.14 4.33-10.68 6.54s-6.92 5-8.6 8.86c-2.6 5.9-.65 12.68-.32 19.12.51 10.15-3.62 20.77-11.82 26.77a10.32 10.32 0 0 0-2.6 2.27 2.86 2.86 0 0 0-.21 3.24c.41.56 1.09.87 1.54 1.39.94 1.08.75 2.7.38 4.08a25.47 25.47 0 0 1-6.87 11.72c.14 1.06 1.42 1.47 2.47 1.63a56.1 56.1 0 0 0 8.39.61 14.05 14.05 0 0 0 11.73-4.72c5-4.71 9.23-10.58 10.36-17.33a5.71 5.71 0 0 1 .94-2.83 4.16 4.16 0 0 1 1.87-1.12c3.73-1.29 8-.66 11.59-2.23 4.68-2 7-7 9.45-11.59.08.88.24 1.76.38 2.63a35.75 35.75 0 0 1-.7 14.12c-.67 2.62-1.64 5.21-1.57 7.91.05 2 2.08 12.44 4.75 9.31s1.69-10 1.69-13.93a59.63 59.63 0 0 1 3.9-21.24c.64-1.69 1.37-3.36 1.86-5.1a28 28 0 0 1 .9-3 15.92 15.92 0 0 1 2.18-3.35l1.91-2.45c3.56-1.88 8.42-3.8 10.31.13.72 1.51 1.11 3.18 3 1.72 1.12-.88 1.48-2.59 1.77-3.89 1.22-5.44 2.2-11.85-1.54-16z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M181.14 475.86c-.73-18.48-26.58-22.3-32.61-4.82-.05.12-.09.23-.13.35-3.94 11.84-2.22 41.8-2.22 41.8s.51 20.11 2.4 26.8 7.2 25.89 7.2 29 4.93 14.92 7 15.78 3.12 7.54 3.63 8.74 2.05 16.81 2.05 16.81 19.38-1.2 19.72-4.29-4.24-18.19-4.24-18.19-3.41-6.18-3.85-11.15-3.18-7.2-2.66-10.63-1.55-5.15-1.55-7.38-1.54-8.23-1.54-8.23-3.26-2.57-2.74-5.66-4.63-9.26-3.26-11.49 1.71-7.72 1.71-7.72 1.68-24.69 2.89-31.42 8.23-17.49 8.23-17.49l-.03-.81z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M180.34 584.21c-4.72 5-11.46 6.09-16.78 5.78-.62-2.34-1.52-5.21-2.83-5.76-2.08-.85-7-12.68-7-15.77s-5.32-22.3-7.2-29-2.4-26.8-2.4-26.8-1.72-30 2.23-41.79c0-.12.07-.24.12-.36 6-17.47 31.88-13.65 32.61 4.82v.85s-7 10.81-8.23 17.49-2.92 31.4-2.92 31.4-.35 5.49-1.72 7.71 3.77 8.41 3.26 11.5 2.74 5.66 2.74 5.66 1.54 6 1.54 8.23 2.06 3.94 1.55 7.37 2.23 5.66 2.67 10.64a27.66 27.66 0 0 0 2.36 8.03z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M180.11 475.34c-.73-18.47-26.58-22.29-32.61-4.82l-.12.36c-3.95 11.83-2.23 41.79-2.23 41.79s.51 20.12 2.4 26.8 7.2 25.9 7.2 29 4.93 14.92 7 15.77 3.12 7.55 3.63 8.75 2.05 16.81 2.05 16.81 19.38-1.2 19.72-4.29-4.29-18.18-4.29-18.18-3.4-6.17-3.84-11.17-3.18-7.2-2.66-10.63-1.55-5.14-1.55-7.37-1.54-8.23-1.54-8.23-3.26-2.58-2.74-5.66-4.63-9.26-3.26-11.49 1.71-7.72 1.71-7.72 1.72-24.7 2.92-31.38 8.23-17.5 8.23-17.5 0-.29-.02-.84z",
    fill: "#9f9eff"
  }), React.createElement("path", {
    d: "M148.28 522.84c.51-.51 10.29-11.32 13.37-7.46s-13.37 7.46-13.37 7.46zM149.18 531.16c.38-.39 9.77-.77 12.09-6s-12.09 6-12.09 6z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M138.48 436.36a2.69 2.69 0 0 1 .51.94 4 4 0 0 0-.51-3.51c-.46-.52-1.13-.84-1.55-1.39l-.08-.15a2.67 2.67 0 0 0 .08 2.72c.42.56 1.09.87 1.55 1.39zM151.57 403.03v-2.92c-.18-3.49-.83-7.09-1-10.59-.2 4.29.76 8.8 1 13.17 0 .11-.01.22 0 .34zM191.65 445.99c-2.38 2.79-4.25-5.24-4.66-8.4a13.09 13.09 0 0 0-.09 1.66c.06 2 2.08 12.44 4.75 9.31 1.81-2.11 2-5.72 1.88-9.06-.1 2.5-.53 4.91-1.88 6.49zM189.17 417.22a34.58 34.58 0 0 1 .37 4.07 35.09 35.09 0 0 0-.37-6.64c-.13-.88-.3-1.75-.38-2.63-2.47 4.61-4.76 9.55-9.44 11.58-3.63 1.58-7.86.95-11.6 2.24a4.21 4.21 0 0 0-1.87 1.12 5.7 5.7 0 0 0-.93 2.82c-1.14 6.76-5.38 12.63-10.37 17.33a14.1 14.1 0 0 1-11.73 4.73 56 56 0 0 1-8.38-.61 5.71 5.71 0 0 1-1.26-.33c-.39.44-.8.87-1.22 1.27.14 1.06 1.43 1.47 2.48 1.63a56 56 0 0 0 8.38.61 14.05 14.05 0 0 0 11.73-4.72c5-4.71 9.23-10.58 10.37-17.33a5.7 5.7 0 0 1 .93-2.83 4.21 4.21 0 0 1 1.87-1.12c3.74-1.29 8-.66 11.6-2.23 4.68-2 7-7 9.44-11.59.08.88.25 1.76.38 2.63zM219.19 394.87c-.29 1.3-.66 3-1.77 3.88-1.88 1.47-2.26-.2-3-1.71-1.89-3.94-6.75-2-10.31-.13l-1.91 2.45a15.25 15.25 0 0 0-2.17 3.35 25.93 25.93 0 0 0-.91 3c-.49 1.74-1.21 3.41-1.86 5.1a59.77 59.77 0 0 0-3.93 21.25v1.05a59.75 59.75 0 0 1 3.91-19.73c.65-1.69 1.37-3.36 1.86-5.1a25.93 25.93 0 0 1 .91-3 15.49 15.49 0 0 1 2.17-3.35l1.91-2.45c3.56-1.88 8.42-3.8 10.31.13.73 1.51 1.11 3.18 3 1.72 1.11-.88 1.48-2.59 1.77-3.89a33.84 33.84 0 0 0 1-9.21 44.15 44.15 0 0 1-.98 6.64z"
  })), React.createElement("path", {
    d: "M242.58 492.23l.53.36a2.12 2.12 0 0 1-.55-2.95l23.84-34.6a2.12 2.12 0 0 1 3-.54l-.53-.37a3.41 3.41 0 0 1 .87 4.74l-22.42 32.49a3.41 3.41 0 0 1-4.74.87z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M269.064 454.293l.404.278-26.242 38.097-.403-.278a1.74 1.74 0 0 1-.446-2.42l24.267-35.23a1.74 1.74 0 0 1 2.42-.447z",
    fill: "#9f9eff"
  }), React.createElement("rect", {
    x: 325.83,
    y: 493.97,
    width: 0.43,
    height: 3.77,
    rx: 0.17,
    ry: 0.17,
    transform: "rotate(34.56 351.529 380.36)",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M980.48 422.53a4.58 4.58 0 0 0 .31-1.66l.62-.31c-.3.66-.6 1.32-.93 1.97z",
    transform: "translate(-61.06 -34.84)",
    fill: "url(#prefix__f)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1071 642.15c0-.3-.09-.59-.16-.89-.67-2.78-1.42-6-2.08-9 .32 1.42 1.42 6.21 2.33 10z",
    transform: "translate(-61.06 -34.84)",
    fill: "url(#prefix__g)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M972.64 288.48l.29-.19.05-.05z",
    transform: "translate(-61.06 -34.84)",
    fill: "url(#prefix__h)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1073.62 663.39c-1-1.33-1.65-5.9-1-7.6s1.56-19.45.82-20.77-4.8-3.18-4.85-3.21l-.18-.81c-.08-.37-.16-.74-.23-1.1a32.36 32.36 0 0 0 4.44-5.27 15.28 15.28 0 0 1-6.28-12.6c0-8.62-9.4-36.25-9.4-36.25s-5.38-7.74-3.36-11.49.22-14.81.22-14.81l4.26-6.86s.67-6.63 1.34-13.48-4-14.37-1.79-17.68-.9-19.88-.9-19.88-2-21.05-5.27-28.1v-.05a59.86 59.86 0 0 1-1.42-9.14c0-.78-.09-1.58-.1-2.39 5.28-9.47 13-23.53 12.74-24.77-.34-1.88 1.79-8.18 1.79-8.18l1.68-15.47s2.69-24.87 2.91-39.23-7.84-19.9-7.84-19.9a6 6 0 0 0-5.54 1.2 5.69 5.69 0 0 1 2.46-1.52l.57-.12a5.25 5.25 0 0 1 2.46.42c-.11-.09-.46-.33-1-.67a4.79 4.79 0 0 0 1.35-.4 3.62 3.62 0 0 0 1.66-1.75 4.16 4.16 0 0 0 .77-1.38h-.16a4.88 4.88 0 0 0 .27-2 9.16 9.16 0 0 0-2-4.5c-4.54-6-12.1-9.59-15.64-16.22-3-5.71-2.51-12.57-1.51-18.93s2.4-12.91.86-19.17a25.38 25.38 0 0 0-10-14.12 40.63 40.63 0 0 0-16.34-6.63c-2.73-.51-5.62-.82-8.25.06-2 .68-3.78 2-5.77 2.83-4.52 1.83-9.72.73-14.46 1.9a19.49 19.49 0 0 0-10.7 7.63 30.29 30.29 0 0 0-2.76 4.65 48.89 48.89 0 0 0-3.28 8.25c-.53 1.69-.24 2.76-.47 3.68a3.45 3.45 0 0 1-.81.71 4.29 4.29 0 0 0-1.21 1.74 5.9 5.9 0 0 0 0 5.83 8.7 8.7 0 0 0 .18 2.3 20.64 20.64 0 0 0 1.24 3.19 53.11 53.11 0 0 1 1.41 38.39c-.58.27-1.16.55-1.77.86 0 0-.38.3-1 .88-2.65 2.52-9.62 10.15-9.08 20.56.67 12.82 0 31.16 0 31.16S961.11 405.8 962 410c-.25 3.88 0 11 4.55 15.66a7.37 7.37 0 0 0 8.43 1.43c2.15-1 4.54-2.58 5.45-4.56-1.6 3.23-3.53 6.23-5.92 7.32-3.36 1.55-2.53 8.85-2.53 8.85s-3.74 4.42-3.07 6.41-5.37 4.2-2.24 7.07c.18.17.47.41.84.72a20.1 20.1 0 0 0-6 11 160.74 160.74 0 0 1-4.15 19.1 1.46 1.46 0 0 0-.85 2.46 8 8 0 0 1-1.23 2.31 42.31 42.31 0 0 0-4.07 5.12 1.46 1.46 0 0 0-1 1.39 1.27 1.27 0 0 0 0 .28c-1.22 2.26-1.85 4.58-.75 6.25 2.46 3.76 2.91 16.58 2.91 16.58s-.9 11.49 1.57 15.25 4.48 27.63-.9 34.7c0 0-1.79 16.36-1.12 17.9s-2.91 5.53-1.79 8.85 6.49 64.32 5.82 66.75c0 0 1.86-.27 4.51-.48-.06.44-.12.89-.19 1.35-.16 1.1-.34 2.26-.55 3.4 0 .24-.08.47-.13.7-1-1.49-2.54-2.29-4.65-.5l-3.13 5.59s-4.59 8.73-9.57 9.5c-3.59.56-7.08 2.86-8.77 4.1-.65.49-1 .82-1 .82s-6.05 5 1.9 7.13a55.37 55.37 0 0 0 6.28 1.21 76.2 76.2 0 0 0 24.71-.65 41.27 41.27 0 0 1 6-.67c7.73-.28 10.36-2.21 10.36-2.21s.78-8.07 0-8.85a2.17 2.17 0 0 1-.29-.44C980.23 678.71 977 670 977 670s-.36 0-.81.54l-.15-.69a48.69 48.69 0 0 1-.94-7.36v-1.33a6.86 6.86 0 0 1 2.41 1.28s.9-6.64 0-11.28.68-23 2.69-27.63 2.47-22.32 1.79-24.09c0 0 3.59-15.69 2.24-18.79S990 549 990 549s3.58-6.85 2.69-7.73c0 0 5.82-3.76 5.15-6.63s5.37-6.19 5.37-6.19 5.38 13 7.17 15 1.86 14.81 4.07 17.46 5.11 16.58 8 20.34 14.56 13.7 16.36 25c0 0 10.52 16.14 10.07 21.22-.18 2.14 1.9 5 5.25 6.36l-.16 1.27-.42 3.53s-3.17.36-3.69 7.28-.38 14.52-1.87 16.51a22.78 22.78 0 0 0-2.74 4.2c-1.66 3.59-1.73 8.23 8.3 9.72 15.34 2.29 19.08-6.19 19.08-6.19a25.62 25.62 0 0 0 1.21-5 2.88 2.88 0 0 0-.22-1.76z",
    transform: "translate(-61.06 -34.84)",
    fill: "url(#prefix__i)"
  }), React.createElement("path", {
    d: "M911.61 268.6a19.91 19.91 0 0 0 1.2 3.14 53 53 0 0 1 .65 39.87c3.59-.23 7.17.35 10.76.63s7.29.23 10.62-1.17 6.24-4.41 6.72-8.12c.66-5-3-9.37-6.19-13.17s-6.4-8.15-7.37-13.2c-1.06-5.55.45-12.06-3.06-16.38a3.48 3.48 0 0 0-1.16-1c-1.89-.86-6.79-.83-8.69.24-2.92 1.64-4.15 5.98-3.48 9.16z",
    fill: "#3e373a"
  }), React.createElement("path", {
    d: "M1010.94 630.74a25.26 25.26 0 0 1-1.18 4.91s-3.63 8.36-18.58 6.1c-9.76-1.47-9.69-6.05-8.07-9.59a22.79 22.79 0 0 1 2.66-4.15c1.45-2 1.31-9.45 1.82-16.28s3.59-7.19 3.59-7.19l.19 7.69c5.82-7.63 9.89 1.31 9.89 1.31s8.27.18 7.26-4.07c-1.08-4.51-2.69-11.67-2.69-11.67s4 1.86 4.73 3.17-.14 18.83-.8 20.5 0 6.18 1 7.49a2.84 2.84 0 0 1 .18 1.78z",
    fill: "#e7c7ca"
  }), React.createElement("path", {
    d: "M1010.94 630.74a25.26 25.26 0 0 1-1.18 4.91s-3.63 8.36-18.58 6.1c-9.76-1.47-9.69-6.05-8.07-9.59 1.37 2 4.46 3.6 11.09 3 10.14-.8 14.53-2.5 16.74-4.42z",
    fill: "#e7c7ca"
  }), React.createElement("path", {
    d: "M1010.94 630.74a25.26 25.26 0 0 1-1.18 4.91s-3.63 8.36-18.58 6.1c-9.76-1.47-9.69-6.05-8.07-9.59 1.37 2 4.46 3.6 11.09 3 10.14-.8 14.53-2.5 16.74-4.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1008.15 609.02a8.14 8.14 0 0 1-5.7 7.77 11 11 0 0 1-9.58-1.46 5.65 5.65 0 0 1-2.37-5.28l.23-1.93.84-7 1.15-9.71s12.38-6.31 11.56-3.92c-.31.89.37 4.89 1.36 9.56.69 3.33 1.54 7 2.29 10.12a8.19 8.19 0 0 1 .22 1.85z",
    fill: "#be6f72"
  }), React.createElement("path", {
    d: "M989.74 608.49s10.72-12.59 19.5 1.15l-1.47 8.8h-18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M989.74 609.36s10.72-12.59 19.5 1.15l-1.47 8.8h-18z",
    fill: "#e7c7ca"
  }), React.createElement("circle", {
    cx: 1003.67,
    cy: 616.05,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 989.73,
    cy: 614.3,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 999.91,
    cy: 623.44,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 990.4,
    cy: 622.15,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 1002.02,
    cy: 619.97,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 989.73,
    cy: 618.23,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 998.82,
    cy: 627.49,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 990.4,
    cy: 626.08,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("path", {
    d: "M917.94 643.93l-14.83 5s-7.85-7.85-5.67-10.25c.93-1 1.74-4.43 2.36-8 .2-1.12.38-2.27.54-3.36.51-3.55.81-6.53.81-6.53s17.23-8.28 14.39 0a20.56 20.56 0 0 0-.81 7.25 48.33 48.33 0 0 0 .92 7.26 68.51 68.51 0 0 0 2.29 8.63z",
    fill: "#be6f72"
  }), React.createElement("path", {
    d: "M917.94 643.93l-14.83 5s-7.85-7.85-5.67-10.25c.93-1 1.74-4.43 2.36-8a15.39 15.39 0 0 1 1.73 4.84c12.82 7 13 2.83 13 2.83a7.71 7.71 0 0 1 1.09-3.05 68.51 68.51 0 0 0 2.32 8.63z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M921.19 655.38s-2.57 1.91-10.09 2.18a40.87 40.87 0 0 0-5.87.66 73 73 0 0 1-24 .65 50.7 50.7 0 0 1-6.12-1.2c-7.74-2.13-1.86-7-1.86-7s.38-.32 1-.81c1.64-1.23 5-3.49 8.53-4 4.85-.77 9.32-9.38 9.32-9.38l3-5.51c4.74-4.09 6.38 5.51 6.38 5.51 12.82 7 13 2.83 13 2.83.71-3.76 2-3.76 2-3.76s3.2 8.6 4.35 10.74a2.17 2.17 0 0 0 .29.44c.82.69.07 8.65.07 8.65z",
    fill: "#e7c7ca"
  }), React.createElement("path", {
    d: "M921.19 655.38s-2.57 1.91-10.09 2.18a40.87 40.87 0 0 0-5.87.66 73 73 0 0 1-24 .65 50.7 50.7 0 0 1-6.12-1.2c-7.74-2.13-1.86-7-1.86-7s.38-.32 1-.81c4.37 1 11.84 2.57 16.54 2.28 7-.43 13.74-1.56 13.74-1.56s12-3.77 16.4-4.33a2.17 2.17 0 0 0 .29.44c.72.73-.03 8.69-.03 8.69z",
    fill: "#e7c7ca"
  }), React.createElement("path", {
    d: "M921.19 655.38s-2.57 1.91-10.09 2.18a40.87 40.87 0 0 0-5.87.66 73 73 0 0 1-24 .65 50.7 50.7 0 0 1-6.12-1.2c-7.74-2.13-1.86-7-1.86-7s.38-.32 1-.81c4.37 1 11.84 2.57 16.54 2.28 7-.43 13.74-1.56 13.74-1.56s12-3.77 16.4-4.33a2.17 2.17 0 0 0 .29.44c.72.73-.03 8.69-.03 8.69z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 901.44,
    cy: 640.01,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 895.2,
    cy: 643.06,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 898.55,
    cy: 641.5,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("circle", {
    cx: 891.68,
    cy: 644.86,
    r: 1.09,
    fill: "#4b4b5b"
  }), React.createElement("path", {
    d: "M915.51 620.81a20.56 20.56 0 0 0-.81 7.25c-3.87-1.3-10.21-1.07-14.39-.72.51-3.55.81-6.53.81-6.53s17.23-8.28 14.39 0zM1005.64 597.01c-5.36 5.25-10.49 5.58-14.07 4.07l1.15-9.71s12.38-6.31 11.56-3.92c-.34.89.37 4.89 1.36 9.56z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M911.59 417.99s-8.51 4.79-10 14.17-4.15 21.38-6.11 23.56-8.07 9.16-5.67 12.86 2.83 16.36 2.83 16.36-.87 11.34 1.53 15.05 4.36 27.26-.87 34.24c0 0-1.75 16.14-1.09 17.67s-2.84 5.45-1.75 8.72 6.33 63.47 5.67 65.87c0 0 16.58-2.4 20.94 1.52 0 0 .87-6.54 0-11.12s.66-22.68 2.62-27.26 2.4-22 1.74-23.78c0 0 3.49-15.48 2.18-18.53s5.64-31.16 5.64-31.16 3.49-6.76 2.62-7.63c0 0 5.67-3.71 5-6.55s5.23-6.1 5.23-6.1 5.24 12.86 7 14.83 1.81 14.61 4 17.23 5 16.35 7.82 20.06 14.17 13.52 15.92 24.65c0 0 10.25 15.92 9.81 20.93s11.56 14.18 23.12-2.83a15.13 15.13 0 0 1-6.1-12.43c0-8.51-9.16-35.77-9.16-35.77s-5.24-7.63-3.28-11.34.22-14.61.22-14.61l4.15-6.77s.65-6.54 1.3-13.3-3.92-14.18-1.74-17.45-.87-19.61-.87-19.61-2.72-28.18-6.76-29.89-75.94-11.59-75.94-11.59z",
    fill: "#4b4b5b"
  }), React.createElement("path", {
    d: "M931.46 378.51s-4.48.51-9.92 1c-7.87.74-17.75 1.49-18.92.72-2-1.31 0-17.89 0-17.89s.68-18.1 0-30.75c-.54-10.26 6.26-17.8 8.84-20.28.6-.57 1-.87 1-.87l2.18 1.74 12.43 21.16zM980.07 308.94l-12.21 7.41-20.07 15.27s-20.72-10.9-15.48-17.23a9.75 9.75 0 0 0 1.91-4.28c1.58-7.28-1.91-17.75-1.91-17.75s27.29-36.86 25.73-8.28c-.62 11.48 2.81 17.74 7.14 21.14 6.45 5.05 14.89 3.72 14.89 3.72z",
    fill: "#be6f72"
  }), React.createElement("ellipse", {
    cx: 942.59,
    cy: 276.16,
    rx: 25.26,
    ry: 26.76,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 942.59,
    cy: 275.29,
    rx: 25.26,
    ry: 26.76,
    fill: "#be6f72"
  }), React.createElement("path", {
    d: "M980.07 308.94l-12.21 7.41-20.07 15.27s-20.72-10.9-15.48-17.23a9.75 9.75 0 0 0 1.91-4.28c22.86 19.54 29.8-.68 31-4.89 6.41 5.05 14.85 3.72 14.85 3.72zM931.46 378.51s-4.48.51-9.92 1c-.21-4.7-.92-10-.79-13.24.22-5.45.22-6.11-1.53-9.16s-1.52-5.45-1.31-9.38c.21-3.76-.78-4.52-4.32-10.53l-.47-.81c-1.74-3-2.24-8.41-2.26-13.52a.06.06 0 0 0 0-.06c0-1.21 0-2.41.07-3.55v-.1c.13-3.45.41-6.4.56-7.8.6-.57 1-.87 1-.87l2.18 1.74 12.43 21.16z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M998.61 314.16h-.05c-7.9-3.41-12.38 13.75-13.58 19.15-.22 1-.33 1.59-.33 1.59s.14 1.45.31 3.75c.59 7.72 1.61 25-.75 29.18a7.17 7.17 0 0 0-.56 1.4c-.74 2.56-.65 6.39-.27 10.12a99.73 99.73 0 0 0 1.93 11.38s5.23 13.31 3.05 22a32.26 32.26 0 0 0-.64 9.89 59.39 59.39 0 0 0 1.38 9c.21.87.35 1.36.35 1.36q-4.93 1.69-9.65 2.81a93.72 93.72 0 0 1-18.65 2.52c-29.49.94-49.12-13.19-53.76-17.05-.37-.3-.64-.54-.82-.71-3-2.83 2.84-5 2.18-7s3-6.32 3-6.32-.81-7.2 2.47-8.72 5.67-6.77 7.51-11.13-.32-15.7-.1-21.15.22-6.11-1.53-9.16-1.52-5.45-1.3-9.38c.21-3.76-.79-4.52-4.33-10.53l-.47-.81c-1.74-3-2.24-8.41-2.25-13.52v-.06c0-1.21 0-2.41.06-3.55v-.06c.18-4.84.66-8.67.66-8.67 17.45-8.95 21.59.37 21.59.37 25.52 22 31.31-5.48 31.31-5.48 13.89-4.75 32.16 8 33.2 8.78z",
    fill: "#e7c7ca"
  }), React.createElement("path", {
    d: "M902.32 376.29s-2.18 11.64 4.13 18.14a7.08 7.08 0 0 0 8.21 1.41c2.1-1 4.45-2.56 5.33-4.52 1.73-3.87-3.71-22.77-17.67-15.03z",
    fill: "#be6f72"
  }), React.createElement("path", {
    d: "M984.21 367.82a7.17 7.17 0 0 0-.56 1.4l1-25.5.31-5.08c.59 7.72 1.61 24.98-.75 29.18zM988.36 412.75a32.26 32.26 0 0 0-.64 9.89c-1.41 2.57-2.62 4.74-3.41 6.15l-1 1.74a40.89 40.89 0 0 0-3.54 5.31 10.36 10.36 0 0 0-1.47 4.31c0 3.35-3.38 25.71-19.41 20.15-10.36-3.59-3.75-14.59 2.23-21.94a82.84 82.84 0 0 1 6.38-7s1.85-2.36 3.63-4.82a29 29 0 0 0 3.13-5c.76-2.18 5.8-11.77 5.8-11.77s5-10.58 3.91-15.49c-.61-2.75-.68-9.54-.62-15a99.73 99.73 0 0 0 1.93 11.38s5.26 13.37 3.08 22.09z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M998.61 314.16s7.85 5.46 7.63 19.63-2.83 38.71-2.83 38.71l-1.64 15.27s-2.07 6.22-1.74 8.07-17.09 32.94-17.09 32.94-5 6.27-5 9.63-3.38 25.7-19.41 20.14 8.61-28.9 8.61-28.9 6-7.63 6.77-9.81 5.79-11.78 5.79-11.78 5-10.57 3.91-15.48-.44-22.72-.44-22.72l1.09-27.88.44-7.09s3.99-23.55 13.91-20.73z",
    fill: "#be6f72"
  }), React.createElement("path", {
    d: "M915.32 366.21l11.91-4.32a5.61 5.61 0 0 1 5.79 1.2L948.81 378s.87 2.4-.29 2.29-18.17-17.13-18.17-17.13l-16.87 5.67a2.8 2.8 0 0 1 1.84-2.62z",
    fill: "#9f9eff"
  }), React.createElement("path", {
    fill: "#4b4b5b",
    d: "M932.16 386.22l16.35-5.92-18.17-17.12-16.87 5.67 18.69 17.37z"
  }), React.createElement("circle", {
    cx: 907.59,
    cy: 433.77,
    r: 1.45,
    fill: "#e7c7ca"
  }), React.createElement("circle", {
    cx: 897.7,
    cy: 452.45,
    r: 1.45,
    fill: "#e7c7ca"
  }), React.createElement("circle", {
    cx: 976.68,
    cy: 459.24,
    r: 1.45,
    fill: "#e7c7ca"
  }), React.createElement("circle", {
    cx: 984.9,
    cy: 485.63,
    r: 1.45,
    fill: "#e7c7ca"
  }), React.createElement("circle", {
    cx: 981.7,
    cy: 478.21,
    r: 1.45,
    fill: "#e7c7ca"
  }), React.createElement("circle", {
    cx: 978.92,
    cy: 468.72,
    r: 1.45,
    fill: "#e7c7ca"
  }), React.createElement("circle", {
    cx: 902.31,
    cy: 442.61,
    r: 1.45,
    fill: "#e7c7ca"
  }), React.createElement("circle", {
    cx: 891.93,
    cy: 462.15,
    r: 1.45,
    fill: "#e7c7ca"
  }), React.createElement("path", {
    d: "M998.56 314.16c-7.9-3.41-12.38 13.75-13.58 19.15l-12.4-17.74s-5.08 8.14-21.52 9.37-20.42-12.5-20.42-12.5c-2.26-.18-12.47 18.2-16.18 24.8l-.47-.81c-1.74-3-2.24-8.41-2.25-13.52v-.06c0-1.18 0-2.37.06-3.55v-.14c.18-4.84.66-8.67.66-8.67 17.45-8.95 21.59.37 21.59.37 25.52 22 31.31-5.48 31.31-5.48 13.89-4.77 32.16 8.02 33.2 8.78z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M901.77 473.6c.22.55 18.54 21.7 25.3 22.79s-25.3-22.79-25.3-22.79zM914.94 441.16s.19 14.92-4.39 18.29 4.39-18.29 4.39-18.29zM923.37 446.45s-.44 17.55 6.1 21.7c0 .01-11.99-11.67-6.1-21.7zM915.3 536.63s-12.22 9-15.6 9.71 15.6-9.71 15.6-9.71zM912.25 259.68c-2.63 2.22-1.69 6.82 1 9s6.37 2.48 9.81 2.56c6.62.18 13.35-.21 19.77 1.42a16.13 16.13 0 0 1 7.58 3.88 17.1 17.1 0 0 1 3.94 7.85 43.07 43.07 0 0 1 1.35 13.14c-.16 3-.62 6-.2 8.91a29 29 0 0 0 2.78 7.93 329.69 329.69 0 0 0 16.85 31.25 5.9 5.9 0 0 0 2.2 2.41c1.57.76 3.42 0 5-.78a37.5 37.5 0 0 1-1.55-9.47 4.23 4.23 0 0 0 4.48-1.56 12.55 12.55 0 0 0 2-4.58l2.93-10.12c.91-3.12 2.26-6.71 5.38-7.63a20.3 20.3 0 0 0 3.3-.77 4.22 4.22 0 0 0 2-4.16 9 9 0 0 0-2-4.44c-4.41-5.94-11.77-9.46-15.22-16-3-5.63-2.45-12.4-1.47-18.68s2.34-12.74.83-18.91a25 25 0 0 0-9.72-13.93 39.27 39.27 0 0 0-15.91-6.54c-2.66-.51-5.47-.82-8 .05-2 .67-3.68 2-5.62 2.79-4.39 1.81-9.46.73-14.08 1.88a18.94 18.94 0 0 0-10.41 7.53 40 40 0 0 0-5.45 11.86c-.85 2.77.51 3.88-2 5.39",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M912.68 258.81c-2.63 2.22-1.68 6.82 1 9s6.36 2.47 9.8 2.56c6.62.17 13.35-.21 19.77 1.42a16 16 0 0 1 7.58 3.88 17.13 17.13 0 0 1 4 7.84 42.85 42.85 0 0 1 1.34 13.15c-.15 3-.62 6-.19 8.91a28.48 28.48 0 0 0 2.78 7.93 329.69 329.69 0 0 0 16.85 31.25 5.73 5.73 0 0 0 2.19 2.4c1.58.77 3.43 0 5-.77a38 38 0 0 1-1.54-9.47 4.26 4.26 0 0 0 4.48-1.56 12.51 12.51 0 0 0 2-4.59l2.94-10.11c.91-3.13 2.25-6.71 5.37-7.63a19.82 19.82 0 0 0 3.3-.77 4.23 4.23 0 0 0 2-4.16 8.89 8.89 0 0 0-2-4.44c-4.41-5.94-11.78-9.47-15.22-16-3-5.62-2.45-12.39-1.47-18.67s2.33-12.74.83-18.91a25.12 25.12 0 0 0-9.73-13.94 39.22 39.22 0 0 0-15.9-6.54 15.86 15.86 0 0 0-8 .06c-2 .67-3.68 2-5.62 2.79-4.4 1.81-9.47.73-14.08 1.88a18.92 18.92 0 0 0-10.41 7.52 39.92 39.92 0 0 0-5.46 11.87c-.85 2.77.52 3.88-2 5.39",
    fill: "#3e373a"
  }), React.createElement("path", {
    d: "M909.94 377.64s20-13.31 25.63-5.13-17.56 18.21-17.56 18.21z",
    fill: "#be6f72"
  }), React.createElement("path", {
    d: "M916.48 314.42c-.08 1.28-.32 2.85-1 3.09 1.86-.05 3.7 1.32 5.55.91 1.37-.3 2.67-1.64 3.5-3.61a1.64 1.64 0 0 1 .47-.77c.19-.11.4 0 .6.12a58.31 58.31 0 0 1 10 7.57c1 1 2.16 2 3.28 1.49a25 25 0 0 0-2.14-10.49 13.38 13.38 0 0 0-5.72-6.26 17.54 17.54 0 0 0-6.72-1.75 6.58 6.58 0 0 1-2.9-.72c-1-.58-4.15-4.36-4.86-1.61-.35 1.33.09 4.16.1 5.64.01 2.13-.04 4.27-.16 6.39z",
    fill: "#3e373a"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M979.63 344.94a5.73 5.73 0 0 1-2.19-2.4 327.44 327.44 0 0 1-16.85-31.25 28.48 28.48 0 0 1-2.78-7.93c-.43-2.95 0-5.94.19-8.92a42.83 42.83 0 0 0-1.35-13.14 17.06 17.06 0 0 0-3.94-7.84 16 16 0 0 0-7.58-3.88c-6.42-1.63-13.15-1.25-19.77-1.42-3.44-.09-7.12-.42-9.8-2.56a6.78 6.78 0 0 1-2.24-7.19 4.57 4.57 0 0 1-.56.45c-2.57 2.23-1.62 6.78 1 8.92s6.37 2.47 9.8 2.56c6.63.17 13.35-.21 19.77 1.42a16 16 0 0 1 7.59 3.88 17.11 17.11 0 0 1 3.94 7.84 43.17 43.17 0 0 1 1.35 13.15c-.16 3-.63 6-.2 8.91a28.48 28.48 0 0 0 2.78 7.93 329.69 329.69 0 0 0 16.85 31.25 5.69 5.69 0 0 0 2.2 2.4c1.57.77 3.42 0 5-.77-.14-.44-.26-.88-.37-1.32a4 4 0 0 1-2.84-.09zM912.47 259.05l.29-.19v-.05zM914.5 256.67l-.28.19.33-.23h-.05c2.07-1.41.87-2.54 1.68-5.2a40.54 40.54 0 0 1 5.32-11.66 25.3 25.3 0 0 0-1.61 2 40.14 40.14 0 0 0-5.45 11.87 18.58 18.58 0 0 0-.43 3.53 4.79 4.79 0 0 1 .49-.5zM1001.21 310.04a19.8 19.8 0 0 1-3.3.76 6.42 6.42 0 0 0-3.65 3.23 5.07 5.07 0 0 1 1.91-1 19.94 19.94 0 0 0 3.29-.77 3.69 3.69 0 0 0 1.81-2.22zM983.09 334.7c0 .75.07 1.51.14 2.26a4.94 4.94 0 0 0 2.59-1.64 7.7 7.7 0 0 0 .86-1.35 3.87 3.87 0 0 1-3.59.73z"
  })), React.createElement("path", {
    d: "M905.13 375.04s5.26-2.13 8.35-1.65M920.3 399.01s2.67 4.15 16.17 5.89-16.17-5.89-16.17-5.89zM915.44 414.5s12.15 10.68 31.63 6.76-31.63-6.76-31.63-6.76z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M656.12 303c-.28-.31-.57-.62-.86-.92 2.25-2.55 4.58-5.17 4.56-8.45 0-4-3.56-7-4.88-10.83-1.8-5.13.69-10.63 1.72-16a30 30 0 0 0-6.49-24.66 8.65 8.65 0 0 0-3.8-2.9c-2.35-.74-4.86.29-7.31.59-8.1 1-15.47-6-23.6-5.35a4.43 4.43 0 0 0-1.57.35 6.6 6.6 0 0 0-2.27 2.57c-2.53 3.72-6.78 5.57-11 7.48a5.94 5.94 0 0 0-1.5.68 41.41 41.41 0 0 0-3.69 1.91c-8 4.72-6.82 11.32-2.12 15.4-.92 4.58-5.6 8.61-4.79 13.31.63 3.69 4.47 6.2 5.21 9.88a9.87 9.87 0 0 1-1.18 6.17c-8.92 2.07-19 5.87-19.79 12.58-1.37 11.68-5.49 43.92-5.49 43.92s-4.77 25.83 13.36 13.62l-.23.68a149.67 149.67 0 0 0-6.65 30.45c-.19 1.54-.56 2.75-1.23 3.15-.24.14.24.37 1.29.66-.12.43-.25.86-.36 1.3a123.35 123.35 0 0 0-3.81 23.06 161.17 161.17 0 0 1-2.84 20.54c-4.3 21.6 0 49.31 0 49.31l9.37 44.12 1.6 7.55a11.23 11.23 0 0 0 3.8 2.74 59.35 59.35 0 0 1 1.3 8.21c0 .31 0 .62.07.93a3.89 3.89 0 0 0-2.78 1.74c-3.34 4.69.47 8.45-12.41 17.84-3.33 2.43-4.93 4.64-5.34 6.51a4.39 4.39 0 0 0 2.21 4.76 7.75 7.75 0 0 0 .9.5c.16.07.32.15.49.21l.51.19.5.16.54.14.51.11h.06l.56.09h.06l.5.06H572l.57-.06h.07l.51-.07h.14l.56-.11h.06l.51-.12h.14l.55-.16.52-.18.14-.06.54-.21c8.59-3.76 26.24-13.62 26.24-13.62v-1.23a1.77 1.77 0 0 0 0-.23V571c-.09-4.1-.5-13.53-2.36-13.16-.64.12-1.07 1-1.52 2.05l-.22-.42c-1.82-3.51-4.45-9.53-4.71-15.41a27.72 27.72 0 0 0 4.06-3.6s-1-4-1.78-8.3c-.7-3.69-1.3-7.55-1.08-9.08.47-3.29-5.73-28.65-5.73-28.65s.64-5.58 1.92-13.33c2.5-15.07 7.41-38.36 14.75-44.95.17-.15.34-.3.51-.43 0 0 5.25.94 9.54 30.53l1.25 13.18a75 75 0 0 0 1.82 10.78 57 57 0 0 1 1.19 17.32c-.54 7.77-.77 16.91-.87 23.33-.08 4.84-.08 8.14-.08 8.14a18.46 18.46 0 0 0 2.86 2v4.31a3.61 3.61 0 0 1-1 2.45 6.76 6.76 0 0 0-1.44 2.65c-.83 1.5-1.54 3.94-1.83 7.86-1 12.68-1.43 11.27-1.43 11.27a16.71 16.71 0 0 0-1.08 4.27 7.7 7.7 0 0 0-.05.83v.51a1.15 1.15 0 0 1 0 .19V576.04c0 .05 0 .23.07.34s0 .1 0 .14a3.37 3.37 0 0 0 .1.34v.11l.12.3a.56.56 0 0 0 0 .08 2.21 2.21 0 0 0 .18.34l.06.08a3.46 3.46 0 0 0 .22.31l.06.07.29.3.33.26h.06a3.61 3.61 0 0 0 .39.22h.08a3 3 0 0 0 .45.18h.08c.17 0 .34.1.53.14a4.89 4.89 0 0 0 .59.09H620.83l.82-.09c10-1.41 14.79-2.35 14.31-8-.29-3.4-1.1-8.33-1.69-11.72a17.86 17.86 0 0 0-1.65-4.94c0-.26.05-.53.07-.81a17.91 17.91 0 0 0-.55-7l.22-4.11a13.1 13.1 0 0 0 6.46-3.87s.07-3 .28-7.09c.32-6.24 1-14.85 2.11-18.27 1.91-5.64 0-25.36 0-25.36s-7.16-33.82-.48-48.38c5.89-12.84 5.84-25.69.17-38.21a2.23 2.23 0 0 0 .31-.3s-1.43-.94-1-11.74c.37-8.25-2-16.76-3.21-20.33a49.76 49.76 0 0 0 5.6 2c11 3.29 11.93-8.92 11.93-8.92l2.47-18.11 2.83-27.3c.75-2.15 1.79-7.5-3.71-13.79zm-48.51-18.09q0 .45-.06.9a12.37 12.37 0 0 1-.61 2.85 18.67 18.67 0 0 0 .59-3.81zm28.85 66.67c.17.31.33.62.48.91l-1.2-.61a27.11 27.11 0 0 1 2.15-6.4 44.64 44.64 0 0 0 2.91-7.38 74.31 74.31 0 0 0 .43 8.79c.95 7.53-4.77 4.71-4.77 4.71z",
    transform: "translate(-61.06 -34.84)",
    fill: "url(#prefix__j)"
  }), React.createElement("path", {
    d: "M534.94 214.65c-1.53 1-3.12 2.24-3.67 4-.87 2.84 1.33 5.7 1.54 8.67.4 5.4-5.71 9.86-4.81 15.2.62 3.66 4.37 6.15 5.09 9.79 1.06 5.31-4.7 10-4.24 15.38.24 2.88 2.24 5.32 4.5 7.1a21.93 21.93 0 0 0 11 4.51c-.27-4.62-3.69-8.82-3.11-13.41.41-3.14 2.62-5.71 3.9-8.62 2.25-5.09 1.53-11 .18-16.39s-3.28-10.72-3.38-16.31c-.06-3.35 1.51-8.27.36-11.45-1.36-3.87-4.75-.25-7.36 1.53z",
    fill: "#7e656a"
  }), React.createElement("path", {
    d: "M534.94 214.78c-1.53 1-3.12 2.24-3.67 4-.87 2.85 1.33 5.71 1.54 8.68.4 5.4-5.71 9.86-4.81 15.2.62 3.66 4.37 6.15 5.09 9.79 1.06 5.31-4.7 10-4.24 15.38.24 2.87 2.24 5.31 4.5 7.09a21.85 21.85 0 0 0 11 4.52c-.27-4.62-3.69-8.82-3.11-13.41.41-3.14 2.62-5.72 3.9-8.62 2.25-5.09 1.53-11 .18-16.39s-3.29-10.75-3.39-16.32c-.06-3.35 1.51-8.28.36-11.46-1.35-3.86-4.74-.24-7.35 1.54z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M539.4 526.4l-4.19 4.19s-14.91 7.92-13-2.79a38.56 38.56 0 0 0 .32-9.63 59.72 59.72 0 0 0-2.65-13.19l14-2.8c-2.32 7.3 1.51 16.5 3.9 21.18.89 1.89 1.62 3.04 1.62 3.04zM571.14 517.93a42 42 0 0 1-.53 4.28s-11.67 7.95-12.58-.93c-.6-5.77.77-8.37 1.8-9.49a3.63 3.63 0 0 0 1-2.43v-10.44l10.24 3.24-.46 8.85a18 18 0 0 1 .53 6.92z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M539.4 526.4l-4.19 4.19s-14.91 7.92-13-2.79a38.56 38.56 0 0 0 .32-9.63c3.26-.48 7.13 3.11 7.13 3.11 5.46 7.7 6.93 4.79 8.09 2.08.92 1.89 1.65 3.04 1.65 3.04z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M529.62 522.21s-6.52-6.06-9.78-1.4.46 8.39-12.11 17.7 0 15.37 8.38 11.65 25.62-13.51 25.62-13.51 0-15.37-2.33-14.91-1.86 11.65-9.78.47z",
    fill: "#8189a6"
  }), React.createElement("path", {
    d: "M571.14 517.93a42 42 0 0 1-.53 4.28s-11.67 7.95-12.58-.93c-.6-5.77.77-8.37 1.8-9.49a2.79 2.79 0 0 1 2.86-.29c1.86-.83 3.91.55 5.61 2.34a16.66 16.66 0 0 1 2.84 4.09z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M562.69 512.43s-5.12-2.8-6.06 9.78-1.39 11.18-1.39 11.18-4.66 11.18 5.12 9.78 14.44-2.33 14-7.92c-.28-3.37-1.06-8.26-1.65-11.61a17 17 0 0 0-4.38-8.87c-1.73-1.79-3.78-3.17-5.64-2.34z",
    fill: "#8189a6"
  }), React.createElement("path", {
    d: "M579.46 452.81s1.86 19.56 0 25.15c-1.13 3.39-1.75 11.93-2.06 18.12-.2 4-.27 7-.27 7-8.85 9.32-19.1 0-19.1 0s0-3.27.08-8.06c.09-6.37.32-15.44.85-23.14a57.22 57.22 0 0 0-1.17-17.18 76.67 76.67 0 0 1-1.8-10.74l-1.22-13.07c-4.19-29.35-9.31-30.28-9.31-30.28-.17.13-.33.28-.5.42-7.16 6.54-12 29.63-14.39 44.58-1.26 7.69-1.88 13.22-1.88 13.22s6 25.16 5.59 28.42c-.22 1.51.37 5.34 1.06 9 .8 4.22 1.73 8.23 1.73 8.23-11.64 12.58-19.56 2.79-19.56 2.79l-1.57-7.45-9.14-43.75s-4.2-27.48 0-48.91a163.94 163.94 0 0 0 2.78-20.37 123.81 123.81 0 0 1 3.71-22.87q.85-3.31 1.89-6.6a229.88 229.88 0 0 1 34-3c12.35 0 24.13 1.71 27.52 7.7q1.18 2.07 2.14 4.15a44.62 44.62 0 0 1 .19 38.7c-6.56 14.4.43 47.94.43 47.94z",
    fill: "#4b4b5b"
  }), React.createElement("path", {
    d: "M540.33 283.73s-24.68-25.15-6-23.29c4.22.42 7.08-.33 9-1.75a9 9 0 0 0 3.32-6.65 27.52 27.52 0 0 0-1.59-10.7s25.15-20 20 5.13a43.27 43.27 0 0 0-1 7.77c-.08 5.34 1.67 7.38 4.14 8.22 4.15 1.42 10.33-.57 13.14 4 5.1 8.42-41.01 17.27-41.01 17.27z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M565.02 246.47a43.27 43.27 0 0 0-1 7.77 18.21 18.21 0 0 1-2 .58 19.66 19.66 0 0 1-4.43.5 19.93 19.93 0 0 1-11-3.28 27.52 27.52 0 0 0-1.59-10.7s25.14-20.02 20.02 5.13z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M577.59 234.36A20 20 0 0 1 562 253.89a19.66 19.66 0 0 1-4.43.5 20 20 0 0 1-20-20v-1.12a20.008 20.008 0 0 1 40 1.12z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M540.33 283.73s-24.68-25.15-6-23.29c4.22.42 7.08-.33 9-1.75-3.61 6-7.66 16.74 10.58 15.72 16.7-.92 16.41-7.58 14.34-11.95 4.15 1.42 10.33-.57 13.14 4 5.05 8.42-41.06 17.27-41.06 17.27z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M579.46 368.04c-4.24 5.51-58.27-1.72-66.17-4.12q.85-3.31 1.89-6.6a229.88 229.88 0 0 1 34-3c12.35 0 24.13 1.71 27.52 7.7q1.18 2.07 2.14 4.15c.25 1.62.62 1.87.62 1.87z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M545.46 256.25s-31.44 2.56-32.84 14.67c-1.34 11.58-5.36 43.55-5.36 43.55s-4.66 25.62 13 13.51l-.22.68a151.1 151.1 0 0 0-6.5 30.2c-.18 1.52-.54 2.73-1.19 3.12-2.33 1.4 62.41 10.71 67.07 4.66 0 0-1.4-.93-.93-11.65s-3.73-21.89-3.73-21.89-3.73-11.18 1.4-21.89 3.26-14 3.26-14l17.7-13.51s3.82-6.55-3.17-14.64a24.2 24.2 0 0 0-16.63-8.2l-12.21-.87s13.38 14.39-11.78 15.79-7.87-19.53-7.87-19.53z",
    fill: "#c3c7d9"
  }), React.createElement("path", {
    d: "M524.5 281.87s.93 7.45-.94 9.78-2.32 13 0 19.56",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M544.94 401.06c-7.16 6.54-12 29.63-14.39 44.58-3.4-20.81 10.69-55.25 10.69-55.25zM537.07 504.51c-11.64 12.58-19.56 2.79-19.56 2.79l-1.57-7.48c4.41 2.29 11.84 4.07 19.4-3.54.8 4.22 1.73 8.23 1.73 8.23zM577.4 496.08c-.2 4-.27 7-.27 7-8.85 9.32-19.1 0-19.1 0s0-3.27.08-8.06a19.19 19.19 0 0 0 19.29 1.06z",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 526.82,
    y: 297.71,
    width: 31.67,
    height: 13.04,
    rx: 3.75,
    ry: 3.75,
    fill: "#cdd0db"
  }), React.createElement("rect", {
    x: 526.82,
    y: 297.71,
    width: 31.67,
    height: 13.04,
    rx: 3.75,
    ry: 3.75,
    opacity: 0.05
  }), React.createElement("rect", {
    x: 526.82,
    y: 298.17,
    width: 31.67,
    height: 13.04,
    rx: 3.75,
    ry: 3.75,
    fill: "#5e5a6b"
  }), React.createElement("circle", {
    cx: 551.74,
    cy: 304.46,
    r: 1.4,
    fill: "#9da7c0"
  }), React.createElement("path", {
    d: "M513.34 318.36a9.1 9.1 0 0 1 5.27-5.55 8.25 8.25 0 0 0 4.51-4c1.84-4.07 5.1-8.26 13.49-5.47s-2.33 4.66-2.33 4.66 19.09-2.79 11.64 2.8a71.7 71.7 0 0 1-16.77 8.85l-4.58 4.85a6.86 6.86 0 0 1-10.24-.2 5.92 5.92 0 0 1-.99-5.94z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M512.88 317.42a9.06 9.06 0 0 1 5.26-5.54 8.28 8.28 0 0 0 4.52-4.06c1.84-4.06 5.1-8.25 13.48-5.46s-2.33 4.66-2.33 4.66 19.1-2.8 11.65 2.79a71.46 71.46 0 0 1-16.77 8.85l-4.59 4.86a6.86 6.86 0 0 1-10.24-.2 6 6 0 0 1-.98-5.9z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M578.53 327.05l-3.26 7.92-4.18-3.07-11.66-8.58-7.92-5.16c-11.18-8.39 0-9.78 0-9.78-4.19-1.87 0-3.73 0-3.73 14.91-3.26 12.11 8.85 12.11 8.85l9.44 4.9 3.14 1.62z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M579.46 326.16l-3.26 7.91-4.18-3.07-11.66-8.57-7.92-5.12c-11.18-8.39 0-9.79 0-9.79-4.19-1.86 0-3.72 0-3.72 14.91-3.26 12.11 8.85 12.11 8.85l9.44 4.89 3.14 1.63z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M579.46 326.16l-3.26 7.91-4.18-3.07c3.78.14 8.24-1.69 2-13.46l3.14 1.63z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M596.69 279.07l.9 3.67-2.76 27.07-2.33 18.17s-.93 12.11-11.64 8.85-11.65-6.52-11.65-6.52 15.37 5.12 5.59-13c0 0 5.59 2.79 4.66-4.66s0-20.5 0-20.5z",
    fill: "#c3c7d9"
  }), React.createElement("path", {
    d: "M577.59 234.36A20 20 0 0 1 562 253.89a10.12 10.12 0 0 1-.66-5.82c.94-3.81 5.34-6.59 4.85-10.48a2.64 2.64 0 0 0-.44-1.22c-1-1.29-3-.65-4.58-.33a8.72 8.72 0 0 1-9.75-6 13.6 13.6 0 0 1-13.85 3.2 20.008 20.008 0 0 1 40 1.12z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M551.94 229.1a8.71 8.71 0 0 0 9.74 6c1.59-.32 3.6-1 4.58.33a2.54 2.54 0 0 1 .44 1.22c.49 3.89-3.9 6.67-4.84 10.47s1.88 7.71 2.49 11.7c.33 2.19 0 4.41 0 6.62s.52 4.59 2.16 6.07 4.67 1.5 5.76-.42c5.25 2.77 3.15 11.35 7.13 15.75 2.2 2.42 5.81 3 9.06 2.69a3.82 3.82 0 0 0 2.13-.68 3.71 3.71 0 0 0 1-2 15.86 15.86 0 0 0-.4-9.42c-.52-1.45-1.27-2.91-1.08-4.44a6.55 6.55 0 0 1 1.62-3.17c2.5-3.1 5.91-6.1 5.89-10.08s-3.48-7-4.77-10.73c-1.76-5.09.68-10.55 1.68-15.84a30 30 0 0 0-6.34-24.45 8.39 8.39 0 0 0-3.7-2.88c-2.3-.74-4.74.29-7.14.59-7.9 1-15.1-5.93-23-5.31a4.22 4.22 0 0 0-1.53.35 6.5 6.5 0 0 0-2.22 2.55c-3.51 5.24-10.4 6.73-15.8 10-15.86 9.52 5.02 26.7 17.14 15.08z",
    fill: "#7e656a"
  }), React.createElement("path", {
    d: "M516.11 548.29c-5.44 2.42-12.65.72-13.6-3.32-1.14 5.33 7.38 8 13.6 5.19 8.39-3.73 25.62-13.51 25.62-13.51v-1.85c-.53.28-17.36 9.82-25.62 13.49zM574.31 534.98c-.54 4.19-5.18 5.07-14 6.33-4.46.63-5.91-1.34-6.18-3.68-.29 3 .56 6.34 6.18 5.54 9.78-1.4 14.44-2.33 14-7.92a2.45 2.45 0 0 0 0-.27z",
    fill: "#fff",
    opacity: 0.3
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M590.28 287.49c-3.26.31-6.87-.27-9.07-2.69-4-4.4-1.88-13-7.12-15.75-1.1 1.92-4.13 1.9-5.77.42s-2.13-3.86-2.16-6.07.33-4.43 0-6.62c-.61-4-3.47-7.78-2.49-11.7s5.34-6.58 4.84-10.47a2.44 2.44 0 0 0-.44-1.22c-1-1.29-3-.65-4.58-.33a8.71 8.71 0 0 1-9.74-6c-10.79 10.39-28.59-2.24-21-11.81-11.88 9.65 7.61 24.75 19.12 13.68a8.71 8.71 0 0 0 9.74 6c1.59-.32 3.6-1 4.58.34a2.46 2.46 0 0 1 .44 1.21c.49 3.89-3.9 6.67-4.84 10.47s1.88 7.71 2.49 11.71c.33 2.18 0 4.41 0 6.62s.52 4.58 2.16 6.06 4.67 1.5 5.76-.42c5.24 2.77 3.15 11.36 7.13 15.75 2.2 2.42 5.81 3 9.06 2.69a3.82 3.82 0 0 0 2.13-.68 3 3 0 0 0 .86-1.37 6.1 6.1 0 0 1-1.1.18zM552.41 202.01l.48-.73h-.12a6.57 6.57 0 0 0-2.22 2.55c-.22.32-.45.64-.69.93a13.13 13.13 0 0 0 2.55-2.75z"
  })), React.createElement("path", {
    d: "M526.82 332.31s-1.2 4.2 6.72 6.06-6.72-6.06-6.72-6.06zM523.36 344.73s-4 2.95 5.71 8.08-5.71-8.08-5.71-8.08zM514.29 393.95s11-3.1 12.47-7.76-12.47 7.76-12.47 7.76zM514.29 452.95s4.72 2.33 7.72 2-7.72-2-7.72-2zM515.94 459.47a15.78 15.78 0 0 0 6.07 1.24c3.93.16-6.07-1.24-6.07-1.24z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 773.48,
    cy: 657.98,
    rx: 19.1,
    ry: 2.62,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 700.33,
    cy: 665.4,
    rx: 19.1,
    ry: 2.62,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 614.17,
    cy: 655.36,
    rx: 19.1,
    ry: 2.62,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 729.61,
    cy: 686.52,
    rx: 13.58,
    ry: 1.86,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 653.69,
    cy: 684.66,
    rx: 13.58,
    ry: 1.86,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M699.94 664.81s26.79-87.8-4.19-123c-23.17-26.31-49.47-23.16-61.25-19.9a21.74 21.74 0 0 0-14 11.67c-4.12 8.89-3.37 23.31 25.7 40.14 48.67 28.18 51.7 66.84 51.7 66.84z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M638.67 534.39s78.95 24.68 61.27 130.42M684.79 543.24s-10.87 7.32-7.42 18.33M646.59 549.76s6.65-6.76 14.74-3M677.8 583.76s11.67-5.92 14.69 1.5M706.68 596.1s-8.76-.69-8.92 3.5",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M701.01 665.51s-31.37-63.82-40-62.42c-4.09.67-6 4.69-6.83 8.74a25.67 25.67 0 0 0 1.76 15.53c4.41 10.21 16.37 29.6 45.07 38.15z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M661.26 615.16s32.92 47.75 39.28 49.84M658.22 622.66h7.69M667.43 640.13l12.04.51M674.76 626.15l-1.31 6.28M687.57 645.25l-.23 5.7",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M700.08 665.51s31.36-63.82 40-62.42c4.09.67 6 4.69 6.83 8.74a25.67 25.67 0 0 1-1.71 15.53c-4.47 10.21-16.42 29.6-45.12 38.15z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M739.83 615.16s-32.89 47.79-39.29 49.88M742.85 622.66h-7.68M733.65 640.13l-12.05.51M726.32 626.15l1.3 6.28M713.51 645.25l.23 5.7",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M646.22 680.41a5.39 5.39 0 0 1-1.79-2.69 2.41 2.41 0 0 1 1.25-2.75c1.14-.44 2.37.36 3.3 1.16s2 1.72 3.2 1.55a4.93 4.93 0 0 1-1.51-4.57 1.93 1.93 0 0 1 .42-.93c.64-.68 1.79-.39 2.55.15 2.43 1.7 3.1 5 3.12 8a15.61 15.61 0 0 0 0-3.28 3.36 3.36 0 0 1 1.23-2.89 3.79 3.79 0 0 1 1.88-.45 3.85 3.85 0 0 1 3 .87 3 3 0 0 1-.12 3.74 11.59 11.59 0 0 1-3.15 2.52 7.11 7.11 0 0 0-2.25 2.15 2.3 2.3 0 0 0-.17.39h-6.74a19.26 19.26 0 0 1-4.22-2.97zM765.74 654.71a5.44 5.44 0 0 1-1.78-2.69 2.4 2.4 0 0 1 1.25-2.75c1.14-.44 2.37.36 3.29 1.16s2 1.72 3.21 1.55a4.88 4.88 0 0 1-1.51-4.57 1.93 1.93 0 0 1 .42-.93c.64-.68 1.79-.39 2.55.15 2.42 1.7 3.1 5 3.11 7.95a15 15 0 0 0 0-3.28 3.31 3.31 0 0 1 1.23-2.89 3.79 3.79 0 0 1 1.88-.45 3.87 3.87 0 0 1 3 .87 3 3 0 0 1-.12 3.74 11.74 11.74 0 0 1-3.15 2.52 7 7 0 0 0-2.25 2.15 2.59 2.59 0 0 0-.17.38h-6.76a19.11 19.11 0 0 1-4.2-2.91zM725.94 680.41a5.46 5.46 0 0 1-1.79-2.69 2.41 2.41 0 0 1 1.25-2.75c1.15-.44 2.37.36 3.3 1.16s2 1.72 3.21 1.55a4.88 4.88 0 0 1-1.51-4.57 1.84 1.84 0 0 1 .42-.93c.63-.68 1.78-.39 2.55.15 2.42 1.7 3.09 5 3.11 8a15 15 0 0 0 0-3.28 3.36 3.36 0 0 1 1.23-2.89 3.79 3.79 0 0 1 1.88-.45 3.85 3.85 0 0 1 3 .87 3 3 0 0 1-.12 3.74 11.59 11.59 0 0 1-3.15 2.52 7.22 7.22 0 0 0-2.25 2.15 2.3 2.3 0 0 0-.17.39h-6.82a19.26 19.26 0 0 1-4.14-2.97zM612.94 628.46s-2.56 3.35 1.18 8.4 6.83 9.31 5.58 12.46c0 0-5.64-9.38-10.24-9.51s-1.58-5.71 3.48-11.35z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M612.94 628.46a4.19 4.19 0 0 0-.52 1.05c-4.48 5.26-6.87 10.18-2.56 10.3 4 .11 8.82 7.29 10 9.1 0 .14-.09.28-.14.41s-5.64-9.38-10.24-9.51-1.6-5.71 3.46-11.35z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M608.17 632.72c0 1.18.14 2.14.3 2.14s.3-1 .3-2.14-.17-.62-.33-.62-.27-.55-.27.62z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M606.54 634.16c1 .56 1.94.9 2 .76s-.7-.72-1.74-1.28-.62-.15-.7 0-.59-.07.44.52z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M626.45 628.46s2.56 3.35-1.18 8.4-6.83 9.31-5.58 12.46c0 0 5.64-9.38 10.23-9.51s1.58-5.71-3.47-11.35z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M626.45 628.46a4.19 4.19 0 0 1 .52 1.05c4.48 5.26 6.87 10.18 2.56 10.3-4 .11-8.82 7.29-10 9.1 0 .14.09.28.14.41s5.64-9.38 10.23-9.51 1.6-5.71-3.45-11.35z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M631.2 632.72c0 1.18-.13 2.14-.29 2.14s-.3-1-.3-2.14.17-.62.33-.62.26-.55.26.62z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M632.84 634.16c-1 .56-1.94.9-2 .76s.7-.72 1.73-1.28.63-.15.71 0 .59-.07-.44.52z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M630.39 648.89s-7.16-.23-9.31-1.76-11-3.37-11.54-.91-10.75 12.25-2.68 12.31 18.77-1.25 20.92-2.56 2.61-7.08 2.61-7.08z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M606.72 657.68c8.08.06 18.77-1.26 20.92-2.57 1.64-1 2.29-4.58 2.51-6.23h.24s-.45 5.77-2.61 7.08-12.84 2.63-20.92 2.56c-2.33 0-3.13-.84-3.09-2.07.33.71 1.22 1.21 2.95 1.23z",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 541.73,
    cy: 760.7,
    rx: 34.72,
    ry: 5.13,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 625.79,
    cy: 806.75,
    rx: 34.72,
    ry: 5.13,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 985.69,
    cy: 737.76,
    rx: 22.99,
    ry: 2.57,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 889.22,
    cy: 760.7,
    rx: 22.99,
    ry: 2.57,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 840.77,
    cy: 806.75,
    rx: 22.99,
    ry: 2.57,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 291.08,
    cy: 825.66,
    rx: 27.19,
    ry: 4.67,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M303.21 778.73s-37.85 19.56-18.29 42.6c0 0 1.84 5 7.16 4.65 0 0-1.06-1.94 3-3.49a19.77 19.77 0 0 0 4.09-2.17 9.64 9.64 0 0 0 3.66-4.9s7.74-10.36 1.74-29.53c0 0 .77-5.42.1-6.29l-4.6 6.31s4.75 3.19 5.3 7.87c0 0-5-7.86-6-7-.22.18-2.29 3.45-2.29 3.45s8.25 5.59 8.86 12.85c0 0-4.64-10.16-9.65-11.61l-2.84 5.12s9 5.48 10 13.72c0 0-5.22-10.46-10.56-12.56l-2.12 5.41s8.68 5.52 9.48 12.38c0 0-7.26-11.48-9.88-11.11 0 0-1.63 5.08-1.41 6.64 0 0 6.13 4.1 6.24 8.13 0 0-5.66-7.15-6.53-6.68 0 0-.37 7.19 1.38 10.93 0 0-3-5.33-2.51-10.93a12 12 0 0 0-3.63 5.85s-1.63-4 3.74-7.59c0 0 .51-5.59 1.13-6.28 0 0-5.81 2.83-8.28 6.32 0 0 .91-5.19 8.78-7.77l2-5.48s-7.88 3.34-10.31 6.28c0 0 1.75-5.16 10.93-7.63l2.72-5s-7 2.36-10.42 5c0 0 2.65-4.43 11.26-6.46l2.21-3.16s-5.08 1.82-6.5 2.47-1.7.33-1.7.33a18.29 18.29 0 0 1 9.11-4.14s4.98-6.19 4.63-6.53z",
    fill: primaryColor
  }));
};
UndrawMobileBrowsers.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawMobileBrowsers;